<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div data-test-view="reviews-update">
            <!-- Congrats Modal -->
            <l-confirmation-modal
                v-show="confirmationModal.show"
                :title="confirmationModal.title"
                :text="confirmationModal.text"
                :btn-text="confirmationModal.btnText"
                :image="confirmationModal.image"
                :label-cancel="confirmationModal.labelCancel"
                :label-confirm="confirmationModal.labelConfirm"
                :show-cancel="confirmationModal.showCancel"
                @confirm="confirmationModal.confirm()"
                @cancel="confirmationModal.cancel()"
            />
            <!--/Congrats Modal -->

            <div v-if="accessDenied" class="row">
                <div class="col-md-6 col-md-offset-3">
                    <div class="card">
                        <div class="card-header">
                            {{ $t(`reviews.update.statusNoAccessTitle`) }}
                        </div>
                        <div class="card-block">
                            {{ $t(`reviews.update.statusNoAccess`) }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="row">
                <div class="col-md-8">
                    <l-card-content>
                        <div class="tab-content">
                            <!-- Peer Nominations Tab -->
                            <div
                                v-if="view === 'peerSelfNominations'"
                                id="home"
                                role="tabpanel"
                                class="tab-pane"
                                :class="{ active: view === 'peerSelfNominations' }"
                            >
                                <l-reviews-update-peer-self-nominations
                                    :review-cycle-id="reviewCycleId"
                                />
                            </div>

                            <!-- End peer nominations tab -->

                            <!-- Peer Nominations Tab -->

                            <div
                                v-if="view === 'peerNominations'"
                                id="home"
                                role="tabpanel"
                                class="tab-pane"
                                :class="{ active: view === 'peerNominations' }"
                            >
                                <l-reviews-update-peer-nominations
                                    :review-cycle-id="reviewCycleId"
                                    :role="role"
                                    :view-as="viewAs"
                                />
                            </div>

                            <!-- End peer nominations tab -->

                            <!-- Start overview / results tab -->

                            <div
                                v-if="view === 'overview' || view === 'questions'"
                                id="home"
                                role="tabpanel"
                                class="tab-pane"
                                :class="{ active: view === 'overview' || view === 'questions' }"
                            >
                                <div style="display: flex;">
                                    <div style="flex: 0 0 10%;" class="hidden-xs">
                                        <l-profile-picture
                                            :user="reviewCycle.revieweeUser"
                                            size="m"
                                        />
                                    </div>

                                    <div style="flex: 0 0 90%;">
                                        <div class="headline">
                                            {{ reviewCycle.reviewTitle }}
                                        </div>

                                        <div class="material-tabs hidden-xs">
                                            <a
                                                class="clickable"
                                                tabindex="0"
                                                @click="goBack()"
                                                @keyup.enter="goBack()"
                                            >
                                                <i class="fal fa-caret-left tw-mr-2"></i>
                                                {{ $t(`reviews.update.menuBack`) }}
                                            </a>
                                            <a
                                                v-show="!expandAllEnabled"
                                                class="clickable"
                                                tabindex="0"
                                                @click="expandAll()"
                                                @keyup.enter="expandAll()"
                                            >
                                                {{ $t(`reviews.update.showDetails`) }}
                                            </a>
                                            <a
                                                v-show="expandAllEnabled"
                                                class="clickable"
                                                tabindex="0"
                                                @click="showOverview()"
                                                @keyup.enter="showOverview()"
                                            >
                                                {{ $t(`reviews.update.showList`) }}
                                            </a>

                                            <a
                                                v-show="
                                                    view !== 'peerNominations' &&
                                                        viewAs === 'reviewee' &&
                                                        mState.contributor >= 3
                                                "
                                                class="clickable"
                                                tabindex="0"
                                                @click="showAccessHolders = !showAccessHolders"
                                                @keyup.enter="
                                                    showAccessHolders = !showAccessHolders
                                                "
                                            >
                                                {{ $t(`reviews.update.btnManageAccessHolders`) }}
                                            </a>
                                            <a
                                                v-show="
                                                    view !== 'peerNominations' &&
                                                        viewAs === 'manager' &&
                                                        mState.contributor >= 3
                                                "
                                                tabindex="0"
                                                @click="showAccessHolders = !showAccessHolders"
                                                @keyup.enter="
                                                    showAccessHolders = !showAccessHolders
                                                "
                                            >
                                                {{ $t(`reviews.update.btnManage2ndManager`) }}
                                            </a>
                                            <a
                                                v-show="
                                                    view !== 'peerNominations' &&
                                                        viewAs === 'peer' &&
                                                        role === 'peer' &&
                                                        mState.contributor === 1
                                                "
                                                class="clickable"
                                                tabindex="0"
                                                @click="showDeclineForm = !showDeclineForm"
                                                @keyup.enter="showDeclineForm = !showDeclineForm"
                                            >
                                                {{
                                                    $t(
                                                        `reviews.update.btnDeclinePeerRequestPreview`,
                                                    )
                                                }}
                                            </a>
                                            <a
                                                v-show="
                                                    view !== 'peerNominations' &&
                                                        viewAs !== 'peer' &&
                                                        reviewCycle.contributors &&
                                                        reviewCycle.contributors.peersDeclined &&
                                                        reviewCycle.contributors.peersDeclined
                                                            .length
                                                "
                                                class="clickable"
                                                tabindex="0"
                                                @click="
                                                    showDeclinedRequests = !showDeclinedRequests
                                                "
                                                @keyup.enter="
                                                    showDeclinedRequests = !showDeclinedRequests
                                                "
                                            >
                                                {{ $t(`reviews.update.btnShowDeclinedRequests`) }}
                                            </a>

                                            <a
                                                v-show="view !== 'peerNominations'"
                                                class="clickable"
                                                tabindex="0"
                                                @click="generatePDF()"
                                                @keyup.enter="generatePDF()"
                                            >
                                                {{ $t(`reviews.update.btnDownloadPDF`) }}
                                            </a>

                                            <a
                                                v-if="
                                                    user.rights.P_MATRIX &&
                                                        reviewCycle.revieweeUser &&
                                                        reviewCycle.revieweeUser._id
                                                "
                                                class="clickable"
                                                :href="
                                                    `/app/#/skill/matrix/${reviewCycle.revieweeUser._id}`
                                                "
                                                target="_blank"
                                            >
                                                {{ $t(`profile.feedback.btnShowSkillMatrix`) }}
                                            </a>

                                            <a
                                                v-if="
                                                    ['manager', 'additionalManager'].includes(
                                                        viewAs,
                                                    ) && view === 'overview'
                                                "
                                                v-b-popover.hover.top="
                                                    $t(`reviews.update.togglePresentationMode`)
                                                "
                                                href="#"
                                                class="tw-cursor-pointer"
                                                @click.prevent="
                                                    isPresentationModeEnabled = !isPresentationModeEnabled
                                                "
                                            >
                                                <i
                                                    class="fal fa-desktop"
                                                    :class="{
                                                        'tw-text-indigo-500 tw-font-bold': isPresentationModeEnabled,
                                                    }"
                                                />
                                                <span class="tw-sr-only">{{
                                                    $t(`reviews.update.togglePresentationMode`)
                                                }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <!-- start summary action -->

                                <div v-show="showDeclineForm">
                                    <span>
                                        {{ $t(`reviews.update.labelPeerRequestDecline`) }}
                                    </span>
                                    <hr />
                                    <l-input-text
                                        v-model="peerDeclineMessage"
                                        type="textarea"
                                        :label="``"
                                        :placeholder="
                                            $t(`reviews.update.placeholderPeerDeclineMessage`)
                                        "
                                        :rows="3"
                                    />
                                    <span v-show="error" class="color-danger explanation">
                                        {{ $t(`reviews.update.labelPeerRequestDeclineMessage`) }}
                                    </span>
                                    <div class="row">
                                        <div class="col-md-3 col-md-offset-9">
                                            <button
                                                class="btn btn-danger btn-raised btn-block pull-right"
                                                @click="declinePeerRequest()"
                                            >
                                                {{
                                                    $t(
                                                        `reviews.update.btnDeclinePeerRequestConfirm`,
                                                    )
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                    <hr />
                                </div>

                                <div
                                    v-if="
                                        showDeclinedRequests &&
                                            reviewCycle.contributors &&
                                            reviewCycle.contributors.peersDeclined &&
                                            reviewCycle.contributors.peersDeclined.length
                                    "
                                >
                                    <span>
                                        {{ $t(`reviews.update.labelPeerRequestDeclinedBy`) }}
                                    </span>
                                    <div
                                        v-for="peer in reviewCycle.contributors.peersDeclined"
                                        :key="peer._id"
                                    >
                                        <strong>
                                            {{ peer.user.firstname }}
                                            {{ peer.user.lastname }} </strong
                                        ><br />
                                        <em>{{ peer.peerDeclineMessage }}</em>
                                    </div>
                                </div>

                                <div v-show="showAccessHolders">
                                    <span>
                                        {{ $t(`reviews.update.labelAccessHoldersH`) }}
                                    </span>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-8">
                                            <l-input-typeahead
                                                style="flex-grow: 1"
                                                :label="``"
                                                :placeholder="
                                                    $t(`reviews.update.nPeersSearchPlaceholder`)
                                                "
                                                :data="users"
                                                :on-select="addAccessHolder"
                                                :on-input-change="typeaheadAccessHolderOnInput"
                                            />
                                        </div>
                                        <div class="col-md-4">
                                            <button
                                                class="btn btn-primary btn-raised btn-block"
                                                @click="updateAccessHolders()"
                                            >
                                                <i
                                                    v-show="updatingAccessHolders"
                                                    class="fal fa-refresh fa-spin"
                                                ></i>
                                                <span>
                                                    {{
                                                        $t(`reviews.update.btnUpdateAccessHolders`)
                                                    }}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            reviewCycle.accessHolders &&
                                                reviewCycle.accessHolders.length
                                        "
                                    >
                                        <span
                                            v-for="(accessHolder,
                                            index) in reviewCycle.accessHolders"
                                            :key="accessHolder._id"
                                            class="r-default-margin-s"
                                        >
                                            <span
                                                class="label label-light clickable"
                                                tabindex="0"
                                                @click="removeAccessHolder(index)"
                                                @keyup.enter="removeAccessHolder(index)"
                                            >
                                                {{ accessHolder.fullname }}
                                                <i class="fal fa-remove"></i>
                                            </span>
                                        </span>
                                    </div>

                                    <hr />
                                </div>

                                <!-- start conversation notes -->

                                <div
                                    v-if="
                                        reviewCycle.conversationsEnabled &&
                                            reviewCycle.managerReviewsEnabled &&
                                            ((viewAs === 'manager' &&
                                                reviewCycle.reviewManagerComplete) ||
                                                (viewAs === 'reviewee' &&
                                                    reviewCycle.reviewRevieweeComplete &&
                                                    reviewCycle.reviewManagerComplete) ||
                                                viewAs === 'owner')
                                    "
                                >
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        !reviewCycle.contributorDetails
                                                            .signatureReviewee
                                                "
                                                class="control-label"
                                            >
                                                {{
                                                    $t(`reviews.update.labelFinalNotes`, {
                                                        firstname:
                                                            reviewCycle.revieweeUser.firstname,
                                                        lastname: reviewCycle.revieweeUser.lastname,
                                                    })
                                                }}
                                            </span>

                                            <span
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        reviewCycle.contributorDetails
                                                            .signatureReviewee
                                                "
                                                class="control-label"
                                            >
                                                <i class="fal fa-lock"></i>
                                                <span class="l-default-margin-s">
                                                    {{
                                                        $t(`reviews.update.labelSignedOn`, {
                                                            firstname:
                                                                reviewCycle.revieweeUser.firstname,
                                                            lastname:
                                                                reviewCycle.revieweeUser.lastname,
                                                        })
                                                    }}</span
                                                >
                                                {{
                                                    reviewCycle.contributorDetails
                                                        .signatureReviewee | moment("MMM DD, YYYY")
                                                }}
                                            </span>

                                            <l-space :size="1" />

                                            <div
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        !reviewCycle.contributorDetails
                                                            .signatureReviewee &&
                                                        viewAs === 'reviewee'
                                                "
                                            >
                                                <l-input-text
                                                    v-model="
                                                        reviewCycle.contributorDetails.notesReviewee
                                                    "
                                                    type="textarea"
                                                    :rows="3"
                                                    :label="``"
                                                    :placeholder="
                                                        $t(`reviews.update.placeholderType`)
                                                    "
                                                />
                                            </div>

                                            <div
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        (reviewCycle.contributorDetails
                                                            .signatureReviewee ||
                                                            viewAs !== 'reviewee')
                                                "
                                            >
                                                <l-text
                                                    :text="
                                                        reviewCycle.contributorDetails.notesReviewee
                                                    "
                                                />

                                                <span
                                                    v-show="
                                                        !(
                                                            reviewCycle.contributorDetails
                                                                .notesReviewee &&
                                                            reviewCycle.contributorDetails
                                                                .notesReviewee.length
                                                        )
                                                    "
                                                    class="color-grey"
                                                >
                                                    {{ $t(`reviews.update.labelNoNotes`) }}
                                                </span>
                                            </div>

                                            <div class="row">
                                                <div
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            !reviewCycle.contributorDetails
                                                                .signatureReviewee
                                                    "
                                                    class="col-md-4"
                                                >
                                                    <button
                                                        v-show="
                                                            viewAs === 'reviewee' &&
                                                                !reviewCycle.contributorDetails
                                                                    .signatureReviewee
                                                        "
                                                        class="btn btn-default btn-raised btn-block"
                                                        @click="
                                                            updateParticipantStatus(
                                                                false,
                                                                false,
                                                                false,
                                                                reviewCycle.contributorDetails
                                                                    .notesReviewee,
                                                            )
                                                        "
                                                    >
                                                        {{ $t(`reviews.update.btnSaveDraft`) }}
                                                    </button>
                                                </div>
                                                <div
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            !reviewCycle.contributorDetails
                                                                .signatureReviewee
                                                    "
                                                    class="col-md-8"
                                                >
                                                    <button
                                                        v-show="
                                                            viewAs === 'reviewee' &&
                                                                !reviewCycle.contributorDetails
                                                                    .signatureReviewee
                                                        "
                                                        class="btn btn-primary btn-raised btn-block"
                                                        @click="
                                                            updateParticipantStatus(
                                                                false,
                                                                false,
                                                                true,
                                                                reviewCycle.contributorDetails
                                                                    .notesReviewee,
                                                            )
                                                        "
                                                    >
                                                        {{ $t(`reviews.update.btnSignNow`) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <template v-if="reviewCycle.managerUser">
                                                <span
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            !reviewCycle.contributorDetails
                                                                .signatureManager
                                                    "
                                                    class="control-label"
                                                >
                                                    {{
                                                        $t(`reviews.update.labelFinalNotes`, {
                                                            firstname:
                                                                reviewCycle.managerUser.firstname,
                                                            lastname:
                                                                reviewCycle.managerUser.lastname,
                                                        })
                                                    }}
                                                </span>

                                                <span
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            reviewCycle.contributorDetails
                                                                .signatureManager
                                                    "
                                                    class="control-label"
                                                >
                                                    <i class="fal fa-lock"></i>
                                                    <span class="l-default-margin-s">
                                                        {{
                                                            $t(`reviews.update.labelSignedOn`, {
                                                                firstname:
                                                                    reviewCycle.managerUser
                                                                        .firstname,
                                                                lastname:
                                                                    reviewCycle.managerUser
                                                                        .lastname,
                                                            })
                                                        }}
                                                    </span>
                                                    {{
                                                        reviewCycle.contributorDetails
                                                            .signatureManager
                                                            | moment("MMM DD, YYYY")
                                                    }}
                                                </span>
                                            </template>

                                            <l-space :size="1" />

                                            <div
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        !reviewCycle.contributorDetails
                                                            .signatureManager &&
                                                        viewAs === 'manager'
                                                "
                                            >
                                                <l-input-text
                                                    v-model="
                                                        reviewCycle.contributorDetails.notesManager
                                                    "
                                                    type="textarea"
                                                    :rows="3"
                                                    :label="``"
                                                    :placeholder="
                                                        $t(`reviews.update.placeholderType`)
                                                    "
                                                />
                                            </div>

                                            <div
                                                v-if="
                                                    reviewCycle.contributorDetails &&
                                                        (reviewCycle.contributorDetails
                                                            .signatureManager ||
                                                            viewAs !== 'manager')
                                                "
                                            >
                                                <l-text
                                                    :text="
                                                        reviewCycle.contributorDetails.notesManager
                                                    "
                                                />
                                                <span
                                                    v-show="
                                                        !(
                                                            reviewCycle.contributorDetails
                                                                .notesReviewee &&
                                                            reviewCycle.contributorDetails
                                                                .notesReviewee.length
                                                        )
                                                    "
                                                    class="color-grey"
                                                >
                                                    {{ $t(`reviews.update.labelNoNotes`) }}
                                                </span>
                                            </div>

                                            <div class="row">
                                                <div
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            !reviewCycle.contributorDetails
                                                                .signatureManager
                                                    "
                                                    class="col-md-4"
                                                >
                                                    <button
                                                        v-show="viewAs === 'manager'"
                                                        class="btn btn-default btn-raised btn-block"
                                                        @click="
                                                            updateParticipantStatus(
                                                                false,
                                                                false,
                                                                false,
                                                                reviewCycle.contributorDetails
                                                                    .notesManager,
                                                            )
                                                        "
                                                    >
                                                        {{ $t(`reviews.update.btnSaveDraft`) }}
                                                    </button>
                                                </div>
                                                <div
                                                    v-if="
                                                        reviewCycle.contributorDetails &&
                                                            !reviewCycle.contributorDetails
                                                                .signatureManager
                                                    "
                                                    class="col-md-8"
                                                >
                                                    <button
                                                        v-show="
                                                            viewAs === 'manager' &&
                                                                !reviewCycle.contributorDetails
                                                                    .signatureManager
                                                        "
                                                        class="btn btn-primary btn-raised btn-block"
                                                        @click="
                                                            updateParticipantStatus(
                                                                false,
                                                                false,
                                                                true,
                                                                reviewCycle.contributorDetails
                                                                    .notesManager,
                                                            )
                                                        "
                                                    >
                                                        {{ $t(`reviews.update.btnSignNow`) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />
                                </div>

                                <!-- end conversation notes -->

                                <!-- Start question overview -->

                                <div
                                    v-if="
                                        !expandAllEnabled &&
                                            reviewCycle.contributors &&
                                            reviewCycle.contributors.all &&
                                            reviewCycle.contributors.all.length
                                    "
                                >
                                    <div class="tw-flex tw-items-center tw-space-x-4">
                                        <div class="tw-flex-1">
                                            &nbsp;
                                        </div>
                                        <div class="tw-flex-grow-0 tw-pr-4">
                                            <span
                                                v-if="displayCurrentViewer"
                                                v-b-popover.hover.top="{
                                                    content: $t(`reviews.update.labelThisReview`),
                                                }"
                                                class="reviewPic"
                                            >
                                                <l-profile-picture
                                                    v-if="reviewCycle.contributorDetails"
                                                    :user="reviewCycle.contributorDetails.user"
                                                    size="s"
                                                />
                                            </span>
                                            <span
                                                v-for="contributor in reviewCycle.contributors.all.slice(
                                                    0,
                                                    8,
                                                )"
                                                :key="contributor._id"
                                                v-b-popover.hover.top="{
                                                    content: contributor.label,
                                                }"
                                                class="reviewPic"
                                            >
                                                <l-profile-picture
                                                    :user="contributor.user"
                                                    size="s"
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <hr />
                                </div>

                                <div
                                    v-if="
                                        Array.isArray(filteredFeedbackSignals) &&
                                            filteredFeedbackSignals.length
                                    "
                                >
                                    <div
                                        v-for="(signal, index) in filteredFeedbackSignals.slice(1)"
                                        :key="signal._id"
                                        style="position:relative;"
                                        tabindex="0"
                                    >
                                        <div
                                            :id="signal.skill"
                                            style="position: absolute; top: -100px; left: 0"
                                        />

                                        <div v-if="signal.skilltype === 'reviewSection'">
                                            <hr v-show="index !== 0" />
                                            <h4 class="color-dark">
                                                <strong>{{ signal.skillname }}</strong>
                                            </h4>
                                            <l-text :text="signal.skilldescription" />
                                            <hr />
                                        </div>

                                        <div
                                            v-show="signal.skilltype !== 'reviewSection'"
                                            class="card card-light mouseover-parent"
                                        >
                                            <!-- start header -->
                                            <label
                                                :for="`signal-${signal.feedbackSignalIndex}`"
                                                style="display: initial; cursor: pointer;"
                                            >
                                                <div
                                                    class="card-header"
                                                    :class="{
                                                        'card-header-semi-rounded': signal.expanded,
                                                        'card-header-rounded': !signal.expanded,
                                                    }"
                                                    @click="
                                                        showNextSkill(
                                                            '',
                                                            signal.feedbackSignalIndex,
                                                            false,
                                                            currentUserIsContributor,
                                                        )
                                                    "
                                                    @keyup.enter="
                                                        showNextSkill(
                                                            '',
                                                            signal.feedbackSignalIndex,
                                                            false,
                                                            currentUserIsContributor,
                                                        )
                                                    "
                                                >
                                                    <div
                                                        class="tw-flex tw-items-center tw-space-x-2"
                                                    >
                                                        <div
                                                            v-if="mState.contributor === 1"
                                                            class="tw-flex-grow-0"
                                                        >
                                                            <span
                                                                v-if="
                                                                    signal.inputRequired &&
                                                                        ((signal.ratingRequirement ==
                                                                            'required' &&
                                                                            signal.amount ===
                                                                                -100) ||
                                                                            (signal.commentRequirement ==
                                                                                'required' &&
                                                                                (signal.content ===
                                                                                    '' ||
                                                                                    signal.content ===
                                                                                        '<p></p>')) ||
                                                                            (signal.answerType ===
                                                                                'multipleChoice' &&
                                                                                !signal.multipleChoiceOptions.some(
                                                                                    o => {
                                                                                        return o.selected;
                                                                                    },
                                                                                )))
                                                                "
                                                                v-b-popover.hover.top="'To Do'"
                                                                style="margin-top: 2px"
                                                            >
                                                                <i
                                                                    v-if="!markIncompleteQuestions"
                                                                    class="fal fa-circle"
                                                                ></i>
                                                                <i
                                                                    v-else
                                                                    class="fas fa-times-circle color-danger"
                                                                ></i>
                                                            </span>
                                                            <span v-else-if="signal.inputRequired">
                                                                <i
                                                                    class="far fa-check-circle color-success"
                                                                ></i>
                                                            </span>
                                                        </div>
                                                        <div
                                                            class="tw-flex-1"
                                                            :class="
                                                                !signal.expanded
                                                                    ? 'tw-truncate'
                                                                    : ''
                                                            "
                                                        >
                                                            <strong>
                                                                {{ signal.label
                                                                }}{{ signal.skillname }}
                                                            </strong>
                                                            <i
                                                                v-if="signal.private"
                                                                v-b-popover.hover.top="
                                                                    $t(
                                                                        `reviews.admin.helpPrivateQuestion`,
                                                                    )
                                                                "
                                                                class="fal fa-lock tw-ml-2"
                                                            />
                                                        </div>
                                                        <div
                                                            v-if="!signal.expanded"
                                                            class="tw-flex-grow-0"
                                                        >
                                                            <span v-show="displayCurrentViewer">
                                                                <span
                                                                    v-b-popover.hover.top="
                                                                        signal.fScale[signal.amount]
                                                                            .label
                                                                    "
                                                                    :class="[
                                                                        signal.fScale[signal.amount]
                                                                            .css,
                                                                        'reviewLabel',
                                                                    ]"
                                                                >
                                                                    {{
                                                                        signal.fScale[signal.amount]
                                                                            .point
                                                                    }}
                                                                </span>
                                                            </span>

                                                            <span
                                                                v-for="contributor in reviewCycle.contributors.all.slice(
                                                                    0,
                                                                    8,
                                                                )"
                                                                :key="contributor._id"
                                                            >
                                                                <span
                                                                    v-if="
                                                                        contributor &&
                                                                            contributor.answers &&
                                                                            signal.skill &&
                                                                            contributor.answers[
                                                                                signal.skill
                                                                            ] &&
                                                                            typeof contributor
                                                                                .answers[
                                                                                signal.skill
                                                                            ].amount !==
                                                                                'undefined' &&
                                                                            signal.fScale &&
                                                                            signal.fScale[
                                                                                contributor.answers[
                                                                                    signal.skill
                                                                                ].amount
                                                                            ]
                                                                    "
                                                                >
                                                                    <span
                                                                        v-b-popover.hover.top="
                                                                            signal.fScale[
                                                                                contributor.answers[
                                                                                    signal.skill
                                                                                ].amount
                                                                            ].label
                                                                        "
                                                                        :class="[
                                                                            signal.fScale[
                                                                                contributor.answers[
                                                                                    signal.skill
                                                                                ].amount
                                                                            ].css,
                                                                            'reviewLabel',
                                                                        ]"
                                                                    >
                                                                        {{
                                                                            signal.fScale[
                                                                                contributor.answers[
                                                                                    signal.skill
                                                                                ].amount
                                                                            ].point
                                                                                ? signal.fScale[
                                                                                      contributor
                                                                                          .answers[
                                                                                          signal
                                                                                              .skill
                                                                                      ].amount
                                                                                  ].point
                                                                                : " "
                                                                        }}
                                                                    </span>
                                                                </span>
                                                                <span v-else>
                                                                    <span
                                                                        class="reviewLabel label label-light"
                                                                        >-</span
                                                                    >
                                                                </span>
                                                            </span>
                                                            <span
                                                                v-show="
                                                                    reviewCycle.contributors.all &&
                                                                        reviewCycle.contributors.all
                                                                            .length > 8
                                                                "
                                                                v-b-popover.hover.top="
                                                                    $t(
                                                                        `reviews.update.helpMoreResults`,
                                                                    )
                                                                "
                                                            >
                                                                <span class="reviewLabel">
                                                                    ...
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                            <!-- end header -->

                                            <!-- start body -->
                                            <div
                                                v-show="signal.expanded"
                                                class="card-block"
                                                style="cursor: initial;"
                                            >
                                                <!-- start general info -->

                                                <div
                                                    v-show="
                                                        signal.skilldescription &&
                                                            signal.skilldescription !== '' &&
                                                            signal.skilltype !== 'goalUser'
                                                    "
                                                    style="margin-bottom: 0px"
                                                    @click.stop="() => {}"
                                                    @keyup.enter="() => {}"
                                                >
                                                    <span
                                                        v-if="
                                                            reviewCycle.revieweeCustomRole &&
                                                                user.rights.P_MATRIX &&
                                                                signal.skilltype !== 'review' &&
                                                                customRolesObj[
                                                                    reviewCycle.revieweeCustomRole
                                                                ]
                                                        "
                                                    >
                                                        {{
                                                            customRolesObj[
                                                                reviewCycle.revieweeCustomRole
                                                            ].name
                                                        }}
                                                        -
                                                    </span>
                                                    <l-text :text="signal.skilldescription" />
                                                    <hr />
                                                </div>

                                                <div
                                                    v-show="signal.skilltype === 'goalUser'"
                                                    style="margin-bottom: 25px"
                                                >
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <strong>
                                                                <span>
                                                                    {{
                                                                        $t(
                                                                            `reviews.update.labelCurrentProgress`,
                                                                        )
                                                                    }}
                                                                </span>
                                                                : {{ signal.progress }}%
                                                            </strong>
                                                            <span
                                                                v-show="signal.status === 'live'"
                                                                class="color-grey"
                                                            >
                                                                -
                                                                <span>
                                                                    {{
                                                                        $t(
                                                                            `reviews.update.labelFreezeToLock`,
                                                                        )
                                                                    }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <a
                                                                :href="
                                                                    `/app/#/goals/details/${signal.skill}`
                                                                "
                                                                target="_blank"
                                                                class="btn-fake"
                                                            >
                                                                <span class="r-default-margin-s">
                                                                    {{
                                                                        $t(
                                                                            `reviews.update.btnViewGoal`,
                                                                        )
                                                                    }}</span
                                                                >
                                                                <i class="fal fa-caret-right"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-for="keyResult in signal.keyResults"
                                                        :key="keyResult._id"
                                                    >
                                                        <div class="hr-small"></div>
                                                        <div class="row">
                                                            <div class="col-md-8 ellipse-text">
                                                                <span
                                                                    v-show="
                                                                        keyResult.type ===
                                                                            'initiative'
                                                                    "
                                                                    v-b-popover.hover.top="
                                                                        `Initiative`
                                                                    "
                                                                    style="margin-right: 2px"
                                                                    class="r-default-margin-s"
                                                                >
                                                                    <i
                                                                        class="fal fa-sticky-note"
                                                                    ></i>
                                                                </span>
                                                                <span
                                                                    v-show="
                                                                        keyResult.type ===
                                                                            'keyResult'
                                                                    "
                                                                    v-b-popover.hover.top="`KR`"
                                                                    class="r-default-margin-s"
                                                                >
                                                                    <i class="fal fa-flag"></i>
                                                                </span>
                                                                {{ keyResult.name }}
                                                            </div>
                                                            <div
                                                                v-b-popover.hover.top="
                                                                    $t(
                                                                        `reviews.update.labelCurrentProgress`,
                                                                    )
                                                                "
                                                                class="col-md-1"
                                                            >
                                                                {{ keyResult.progress }}%
                                                            </div>
                                                            <div class="col-md-3">
                                                                <span
                                                                    v-show="
                                                                        keyResult.metricType !==
                                                                            'none'
                                                                    "
                                                                >
                                                                    {{ keyResult.metricCurrent }}
                                                                    /
                                                                    {{ keyResult.metricEnd }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- end general info -->

                                                <!-- start on card question form -->

                                                <div
                                                    v-if="
                                                        mState.contributor === 1 &&
                                                            entrypoint !== 'received' &&
                                                            signal.applicableToRole
                                                    "
                                                >
                                                    <!-- scale -->

                                                    <div
                                                        v-if="
                                                            reviewCycle.feedbackSignals[
                                                                signal.feedbackSignalIndex
                                                            ].ratingRequirement !== 'hidden'
                                                        "
                                                    >
                                                        <!-- scale component -->

                                                        <l-feedback-scale
                                                            :scale="
                                                                reviewCycle.feedbackSignals[
                                                                    signal.feedbackSignalIndex
                                                                ].scale
                                                            "
                                                            :amount="
                                                                reviewCycle.feedbackSignals[
                                                                    signal.feedbackSignalIndex
                                                                ].amount
                                                            "
                                                            :feedback-signal-index="
                                                                signal.feedbackSignalIndex
                                                            "
                                                            :rating-requirement="
                                                                signal.ratingRequirement
                                                            "
                                                            @update="updateAmount"
                                                        />

                                                        <hr />
                                                    </div>

                                                    <!-- comment -->

                                                    <div
                                                        v-if="
                                                            reviewCycle.feedbackSignals[
                                                                signal.feedbackSignalIndex
                                                            ].commentRequirement !== 'hidden'
                                                        "
                                                    >
                                                        <l-rich-text-editor
                                                            v-model="
                                                                reviewCycle.feedbackSignals[
                                                                    signal.feedbackSignalIndex
                                                                ].content
                                                            "
                                                            :content="
                                                                reviewCycle.feedbackSignals[
                                                                    signal.feedbackSignalIndex
                                                                ].content
                                                            "
                                                            @input="autoSave()"
                                                        />
                                                        <div class="row" style="margin-bottom: 0px">
                                                            <div class="col-md-12">
                                                                <div style="margin-top: 15px">
                                                                    <span
                                                                        v-show="
                                                                            !error &&
                                                                                signal.inputRequired &&
                                                                                signal.ratingRequirement ==
                                                                                    'required' &&
                                                                                signal.amount ===
                                                                                    -100 &&
                                                                                reviewCycle.scale
                                                                                    .type != '100'
                                                                        "
                                                                        class="explanation color-grey l-default-margin-s"
                                                                    >
                                                                        <i
                                                                            class="fal fa-hand-pointer"
                                                                        ></i>
                                                                        <span
                                                                            class="l-default-margin-s"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    `feedback.create.labelProvideScore`,
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </span>

                                                                    <span
                                                                        v-show="
                                                                            !error &&
                                                                                signal.inputRequired &&
                                                                                signal.commentRequirement ==
                                                                                    'required' &&
                                                                                (signal.content ===
                                                                                    '' ||
                                                                                    signal.content ===
                                                                                        '<p></p>')
                                                                        "
                                                                        class="explanation color-grey l-default-margin-s"
                                                                    >
                                                                        <i
                                                                            class="fal fa-comment"
                                                                        ></i>
                                                                        &nbsp;
                                                                        <span
                                                                            class="l-default-margin-s"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    `feedback.create.labelProvideComment`,
                                                                                )
                                                                            }}
                                                                        </span>
                                                                        &nbsp;
                                                                    </span>

                                                                    <span
                                                                        v-show="
                                                                            !error &&
                                                                                signal.amount >=
                                                                                    0 &&
                                                                                signal.amount <
                                                                                    50 &&
                                                                                (signal.content ===
                                                                                    '' ||
                                                                                    signal.content ===
                                                                                        '<p></p>') &&
                                                                                signal.commentRequirement !=
                                                                                    'required'
                                                                        "
                                                                        class="explanation color-grey l-default-margin-s"
                                                                    >
                                                                        <i
                                                                            class="fal fa-comment"
                                                                        ></i>
                                                                        <span
                                                                            class="l-default-margin-s"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    `feedback.create.labelProvideExamples`,
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </span>

                                                                    <span
                                                                        v-if="
                                                                            error &&
                                                                                signal.feedbackSignalIndex ==
                                                                                    index
                                                                        "
                                                                        class="explanation color-danger"
                                                                    >
                                                                        <i
                                                                            class="fa fa-warning l-default-margin-s"
                                                                        ></i>
                                                                        {{ error.message }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- multiple choice -->

                                                    <div
                                                        v-show="
                                                            reviewCycle.feedbackSignals[
                                                                signal.feedbackSignalIndex
                                                            ].answerType === 'multipleChoice'
                                                        "
                                                        style="margin-top: 20px"
                                                    >
                                                        <div
                                                            v-for="(option, mcIndex) in reviewCycle
                                                                .feedbackSignals[
                                                                signal.feedbackSignalIndex
                                                            ].multipleChoiceOptions"
                                                            :key="option.title"
                                                        >
                                                            <label class="color-dark">
                                                                <input
                                                                    v-model="option.selected"
                                                                    type="checkbox"
                                                                    @click="
                                                                        () => {
                                                                            selectOption(
                                                                                signal.feedbackSignalIndex,
                                                                                option,
                                                                            );

                                                                            autoSave();
                                                                        }
                                                                    "
                                                                />
                                                                {{ option.title }}
                                                            </label>
                                                            <div
                                                                v-show="
                                                                    mcIndex !=
                                                                        reviewCycle.feedbackSignals[
                                                                            signal
                                                                                .feedbackSignalIndex
                                                                        ].multipleChoiceOptions
                                                                            .length -
                                                                            1
                                                                "
                                                                class="hr-small"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- end on card question form -->

                                                <!-- answer of current viewer -->

                                                <div
                                                    v-show="
                                                        signal.applicableToRole &&
                                                            mState.contributor > 1
                                                    "
                                                >
                                                    <div style="display: flex; margin-bottom: 15px">
                                                        <!-- picture -->

                                                        <div
                                                            v-b-popover.hover.top="
                                                                $t(`reviews.update.labelThisReview`)
                                                            "
                                                            style="flex-basis: auto"
                                                            class="r-default-margin"
                                                        >
                                                            <l-profile-picture
                                                                :user="user"
                                                                size="s"
                                                            />
                                                        </div>

                                                        <!-- scale -->
                                                        <div
                                                            v-show="
                                                                signal.answerType !==
                                                                    'multipleChoice'
                                                            "
                                                            style="flex-basis: auto"
                                                        >
                                                            <span
                                                                v-b-popover.hover.top="
                                                                    signal.fScale[signal.amount]
                                                                        .label
                                                                "
                                                                :class="[
                                                                    signal.fScale[signal.amount]
                                                                        .css,
                                                                    'reviewLabel',
                                                                ]"
                                                                style="margin-right: 20px; margin-top: 5px"
                                                            >
                                                                {{
                                                                    signal.fScale[signal.amount]
                                                                        .point
                                                                        ? signal.fScale[
                                                                              signal.amount
                                                                          ].point
                                                                        : " "
                                                                }}
                                                            </span>
                                                        </div>

                                                        <!-- comment -->

                                                        <div
                                                            v-show="
                                                                signal.answerType !==
                                                                    'multipleChoice'
                                                            "
                                                            style="flex: 0 0 70%"
                                                        >
                                                            <div v-html="signal.content" />
                                                            <span
                                                                v-show="
                                                                    !signal.content ||
                                                                        !signal.content.length
                                                                "
                                                                class="color-grey"
                                                            >
                                                                <em>
                                                                    {{
                                                                        $t(
                                                                            `reviews.update.labelNoComment`,
                                                                        )
                                                                    }}
                                                                </em>
                                                            </span>
                                                        </div>

                                                        <!-- multiple choice -->

                                                        <div
                                                            v-show="
                                                                signal.answerType ===
                                                                    'multipleChoice'
                                                            "
                                                            style="flex: 0 0 70%;"
                                                        >
                                                            <div
                                                                v-for="option in signal.multipleChoiceOptions"
                                                                v-show="option.selected"
                                                                :key="option.title"
                                                                style="padding-top: 3px"
                                                            >
                                                                <i class="fal fa-check-square"></i>
                                                                &nbsp;
                                                                {{ option.title }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- end answer of current viewer -->

                                                <!-- answers from contributors -->

                                                <div
                                                    v-for="contributor in reviewCycle.contributors
                                                        .all"
                                                    v-show="
                                                        contributor &&
                                                            contributor.answers &&
                                                            signal.skill &&
                                                            contributor.answers[signal.skill]
                                                    "
                                                    :key="contributor._id"
                                                    style="margin-top: 20px"
                                                >
                                                    <div style="display: flex; margin-bottom: 15px">
                                                        <!-- picture -->

                                                        <div
                                                            v-b-popover.hover.top="
                                                                contributor.label
                                                            "
                                                            style="flex-basis: auto"
                                                            class="r-default-margin"
                                                        >
                                                            <l-profile-picture
                                                                :user="contributor.user"
                                                                size="s"
                                                            />
                                                        </div>

                                                        <!-- scale -->
                                                        <div
                                                            v-if="
                                                                signal.answerType !==
                                                                    'multipleChoice'
                                                            "
                                                            style="flex-basis: auto"
                                                        >
                                                            <span
                                                                v-if="
                                                                    contributor &&
                                                                        contributor.answers &&
                                                                        signal.skill &&
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ] &&
                                                                        typeof contributor.answers[
                                                                            signal.skill
                                                                        ].amount !== 'undefined' &&
                                                                        signal.fScale &&
                                                                        signal.fScale[
                                                                            contributor.answers[
                                                                                signal.skill
                                                                            ].amount
                                                                        ]
                                                                "
                                                                v-b-popover.hover.top="
                                                                    signal.fScale[
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ].amount
                                                                    ].label
                                                                "
                                                                :class="[
                                                                    signal.fScale[
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ].amount
                                                                    ].css,
                                                                    'reviewLabel',
                                                                ]"
                                                                style="margin-right: 20px; margin-top: 5px"
                                                            >
                                                                {{
                                                                    signal.fScale[
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ].amount
                                                                    ].point
                                                                        ? signal.fScale[
                                                                              contributor.answers[
                                                                                  signal.skill
                                                                              ].amount
                                                                          ].point
                                                                        : ""
                                                                }}
                                                            </span>
                                                        </div>

                                                        <!-- comment -->

                                                        <div
                                                            v-if="
                                                                signal.answerType !==
                                                                    'multipleChoice'
                                                            "
                                                            style="flex: 0 0 70%"
                                                        >
                                                            <div
                                                                v-if="
                                                                    contributor &&
                                                                        contributor.answers &&
                                                                        signal.skill &&
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ] &&
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ].content
                                                                "
                                                                v-html="
                                                                    contributor.answers[
                                                                        signal.skill
                                                                    ].content
                                                                "
                                                            ></div>
                                                            <span v-else class="color-grey">
                                                                <em>
                                                                    {{
                                                                        $t(
                                                                            `reviews.update.labelNoComment`,
                                                                        )
                                                                    }}
                                                                </em>
                                                            </span>
                                                        </div>

                                                        <!-- multiple choice -->

                                                        <div
                                                            v-show="
                                                                signal.answerType ===
                                                                    'multipleChoice'
                                                            "
                                                            style="flex: 0 0 70%;"
                                                        >
                                                            <div
                                                                v-for="option in signal.multipleChoiceOptions"
                                                                v-show="
                                                                    contributor &&
                                                                        contributor.answers &&
                                                                        signal.skill &&
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ] &&
                                                                        Array.isArray(
                                                                            contributor.answers[
                                                                                signal.skill
                                                                            ].answers,
                                                                        ) &&
                                                                        contributor.answers[
                                                                            signal.skill
                                                                        ].answers.indexOf(
                                                                            option._id,
                                                                        ) > -1
                                                                "
                                                                :key="option.title"
                                                                style="padding-top: 3px"
                                                            >
                                                                <i class="fal fa-check-square"></i>
                                                                &nbsp;
                                                                {{ option.title }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    v-show="
                                                        !signal.applicableToRole &&
                                                            !(
                                                                reviewCycle.contributors.all &&
                                                                reviewCycle.contributors.all.length
                                                            )
                                                    "
                                                    class="color-grey"
                                                >
                                                    <i class="fal fa-spinner"></i>
                                                    <span class="l-default-margin-s">
                                                        {{ $t(`reviews.update.labelNoInputYet`) }}
                                                    </span>
                                                </div>

                                                <!-- end answers from contributors -->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        reviewCycle.scale &&
                                            reviewCycle.scale.type !== '100' &&
                                            !reviewCycle.scale.hideNumbers &&
                                            statsManager &&
                                            statsManager.avg &&
                                            parseFloat(statsManager.avg) !== 0
                                    "
                                >
                                    <hr />
                                    <p v-if="!reviewCycle.questions.customScoresEnabled">
                                        <l-text
                                            :text="
                                                $t(`reviews.update.scoreAllManager`, {
                                                    avg: statsManager.avg,
                                                    scale: reviewCycle.mixedScale
                                                        ? '100'
                                                        : reviewCycle.scale.type,
                                                })
                                            "
                                        />
                                    </p>
                                    <p v-if="reviewCycle.questions.customScoresEnabled">
                                        <l-text
                                            :text="
                                                $t(`reviews.update.scoreAllManagerCustom`, {
                                                    avg: statsManager.avg,
                                                    company: statsManager.company,
                                                    wCompany:
                                                        reviewCycle.questions.companySkills.weight,
                                                    team: statsManager.teams,
                                                    wTeam: reviewCycle.questions.teamSkills.weight,
                                                    goals: statsManager.goals,
                                                    wGoals: reviewCycle.questions.goals.weight,
                                                    questions: statsManager.questions,
                                                    scale: reviewCycle.mixedScale
                                                        ? '100'
                                                        : reviewCycle.scale.type,
                                                })
                                            "
                                        />
                                    </p>
                                    <hr />
                                </div>

                                <div v-if="!report.noResults" class="material-tabs hidden-xs">
                                    <a
                                        class="clickable"
                                        :class="{ active: reportChartStyle === 'radar' }"
                                        tabindex="0"
                                        @click="getReport(report.source, 'skill', 'radar')"
                                        @keyup.enter="getReport(report.source, 'skill', 'radar')"
                                    >
                                        <i class="fal fa-chart-pie"></i> &nbsp;
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnShowQuestion`)
                                        }}</span>
                                        <span class="material-tabs-bar"></span>
                                    </a>

                                    <a
                                        class="clickable"
                                        :class="{ active: reportChartStyle === 'bar' }"
                                        tabindex="0"
                                        @click="getReport(report.source, 'skill', 'bar')"
                                        @keyup.enter="getReport(report.source, 'skill', 'bar')"
                                    >
                                        <i class="fal fa-chart-bar"></i> &nbsp;
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnShowQuestion`)
                                        }}</span>
                                        <span class="material-tabs-bar"></span>
                                    </a>

                                    <a
                                        v-if="
                                            reviewCycle.questions &&
                                                Array.isArray(reviewCycle.questions.categories) &&
                                                reviewCycle.questions.categories.length
                                        "
                                        class="clickable"
                                        :class="{ active: reportChartStyle === 'radarCategory' }"
                                        tabindex="0"
                                        @click="
                                            getReport(report.source, 'category', 'radarCategory')
                                        "
                                        @keyup.enter="
                                            getReport(report.source, 'category', 'radarCategory')
                                        "
                                    >
                                        <i class="fal fa-chart-pie"></i> &nbsp;
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnShowCategory`)
                                        }}</span>
                                        <span class="material-tabs-bar"></span>
                                    </a>

                                    <a
                                        v-if="
                                            reviewCycle.questions &&
                                                Array.isArray(reviewCycle.questions.categories) &&
                                                reviewCycle.questions.categories.length
                                        "
                                        class="clickable"
                                        :class="{ active: reportChartStyle === 'barCategory' }"
                                        tabindex="0"
                                        @click="getReport(report.source, 'category', 'barCategory')"
                                        @keyup.enter="
                                            getReport(report.source, 'category', 'barCategory')
                                        "
                                    >
                                        <i class="fal fa-chart-bar"></i> &nbsp;
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnShowCategory`)
                                        }}</span>
                                        <span class="material-tabs-bar"></span>
                                    </a>

                                    <a
                                        v-b-popover.hover.top="$t(`reviews.update.helpExportChart`)"
                                        class="pull-right clickable"
                                        tabindex="0"
                                        @click="generatePNG()"
                                        @keyup.enter="generatePNG()"
                                    >
                                        <i class="fal fa-download"></i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.update.btnExportChart`)
                                        }}</span>
                                    </a>
                                </div>

                                <div
                                    v-if="
                                        reportChartStyle === 'radar' &&
                                            !report.noResults &&
                                            !isChartLoading
                                    "
                                    style="margin-top: 10px"
                                >
                                    <l-chart
                                        :ref="`chart-${reportChartStyle}`"
                                        type="radar"
                                        height="200"
                                        :colors="['green', 'grey', 'red', 'primary', 'orange']"
                                        :data="dataSnapshot"
                                        :options="graphSettings.options"
                                    />
                                </div>
                                <div
                                    v-if="
                                        reportChartStyle === 'radarCategory' &&
                                            !report.noResults &&
                                            !isChartLoading
                                    "
                                    style="margin-top: 10px"
                                >
                                    <l-chart
                                        :ref="`chart-${reportChartStyle}`"
                                        type="radar"
                                        height="200"
                                        :colors="['green', 'grey', 'red', 'primary', 'orange']"
                                        :data="dataSnapshot"
                                        :options="graphSettings.options"
                                    />
                                </div>

                                <div
                                    v-if="
                                        reportChartStyle === 'bar' &&
                                            !report.noResults &&
                                            !isChartLoading
                                    "
                                    style="margin-top: 10px"
                                >
                                    <l-chart
                                        :ref="`chart-${reportChartStyle}`"
                                        type="horizontalBar"
                                        :height="String(dataHorizontalBar.labels.length * 80)"
                                        :data="dataHorizontalBar"
                                        :colors="['green', 'grey', 'red', 'primary', 'orange']"
                                        :options="{
                                            legend: {
                                                display: true,
                                                position: 'bottom',
                                                labels: { boxWidth: 15, padding: 20 },
                                            },
                                            scales: { xAxes: [{ ticks: { display: false } }] },
                                        }"
                                    />
                                </div>
                                <div
                                    v-if="
                                        reportChartStyle === 'barCategory' &&
                                            !report.noResults &&
                                            !isChartLoading
                                    "
                                    style="margin-top: 10px"
                                >
                                    <l-chart
                                        :ref="`chart-${reportChartStyle}`"
                                        type="horizontalBar"
                                        :height="String(dataHorizontalBar.labels.length * 80)"
                                        :data="dataHorizontalBar"
                                        :colors="['green', 'grey', 'red', 'primary', 'orange']"
                                        :options="{
                                            legend: {
                                                display: true,
                                                position: 'bottom',
                                                labels: { boxWidth: 15, padding: 20 },
                                            },
                                            scales: { xAxes: [{ ticks: { display: false } }] },
                                        }"
                                    />
                                </div>

                                <!-- End key stats -->
                            </div>

                            <!-- End overview / results tab -->
                        </div>
                    </l-card-content>
                </div>

                <div class="col-md-4">
                    <div class="card card-sidebar" style="margin-left: -10px !important">
                        <div class="card-block">
                            <l-reviews-update-context-panel
                                :review-cycle="reviewCycle"
                                :role="role"
                                :view-as="viewAs"
                                :view="view"
                                :contributor-id="contributorId"
                                :reviewee-id="revieweeId"
                                :entrypoint="entrypoint"
                                :m-state="mState"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Status Bar -->

        <div
            v-if="
                !['peerNominations', 'peerSelfNominations'].includes(view) &&
                    currentUserIsContributor &&
                    (mState.contributor < 3 || canEdit)
            "
            class="tw-mt-12"
        >
            <div class="tw-fixed tw-bottom-0 tw-w-full tw-z-50 tw-bg-gray-50 tw-left-0">
                <div class="tw-h-2 tw-bg-gray-100">
                    <div
                        class="tw-h-2 tw-bg-gray-300 tw-transition-all tw-duration-300"
                        :style="{ width: `${progress.mandatory}%` }"
                    ></div>
                </div>

                <div class="tw-flex tw-justify-center tw-items-center tw-p-4 tw-space-x-2">
                    <div class="tw-w-2/3 tw-select-none">
                        <div
                            v-if="reviewCycle.visibilitySubmitted"
                            class="tw-flex tw-space-x-4 tw-text-center"
                        >
                            <div class="tw-flex-1 text-center color-grey">
                                <i
                                    class="r-default-margin-s"
                                    :class="{
                                        'fal fa-sync fa-spin': showAutoSaving,
                                        'fal fa-check-circle': !showAutoSaving,
                                    }"
                                ></i>
                                <span>{{ $t(`reviews.update.labelPrepare`) }}</span>
                            </div>
                            <div
                                v-if="
                                    !(
                                        reviewCycle.visibilitySubmitted &&
                                        reviewCycle.visibilitySubmitted.html &&
                                        reviewCycle.visibilitySubmitted.html.length
                                    ) ||
                                        !(
                                            reviewCycle.visibilityShared &&
                                            reviewCycle.visibilityShared.html &&
                                            reviewCycle.visibilityShared.html.length
                                        )
                                "
                                class="tw-flex-1 text-center color-grey"
                            >
                                <i class="fal fa-caret-right"></i>
                            </div>
                            <div
                                v-if="
                                    reviewCycle.visibilitySubmitted &&
                                        reviewCycle.visibilitySubmitted.html &&
                                        reviewCycle.visibilitySubmitted.html.length
                                "
                                v-b-popover.hover.top="{
                                    title: $t(`reviews.update.visibilitySubmit`),
                                    content: reviewCycle.visibilitySubmitted.html,
                                    html: true,
                                }"
                                class="tw-flex-1 text-center color-grey"
                            >
                                <i
                                    class="r-default-margin-s"
                                    :class="
                                        mState.contributor === 1
                                            ? 'fal fa-question-circle'
                                            : 'fal fa-check-circle'
                                    "
                                ></i>
                                <span class="help">{{ $t(`reviews.update.btnSubmit`) }}</span>
                            </div>
                            <div
                                v-if="
                                    reviewCycle.visibilityShared &&
                                        reviewCycle.visibilityShared.html &&
                                        reviewCycle.visibilityShared.html.length
                                "
                                v-b-popover.hover.top="{
                                    title: $t(`reviews.update.visibilityShare`),
                                    content: reviewCycle.visibilityShared.html,
                                    html: true,
                                }"
                                class="tw-flex-1 text-center color-grey"
                            >
                                <i
                                    class="r-default-margin-s"
                                    :class="
                                        mState.contributor < 3
                                            ? 'fal fa-question-circle'
                                            : 'fal fa-check-circle'
                                    "
                                ></i>
                                <span class="help">{{ $t(`reviews.update.btnShare`) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="tw-text-right tw-w-1/3">
                        <div class="tw-flex tw-space-x-2 tw-justify-end tw-pr-4">
                            <!-- edits -->

                            <button
                                v-show="canEdit"
                                class="btn btn-default btn-raised tw-w-1/2"
                                style="margin-top: 5px"
                                @click="updateParticipantStatus('pending', 'private', false)"
                            >
                                {{ $t(`reviews.update.btnEdit`) }}
                            </button>

                            <!-- finalize additional manager / peer / direct report review or self-evaluation -->

                            <button
                                v-show="
                                    mState.contributor === 1 &&
                                        [
                                            'reviewee',
                                            'peer',
                                            'directReport',
                                            'additionalManager',
                                        ].includes(role) &&
                                        currentUserIsContributor
                                "
                                class="btn btn-primary btn-raised tw-w-1/2"
                                style="margin-top: 5px"
                                @click="updateParticipantStatus('complete', 'shared', false)"
                            >
                                {{ $t(`reviews.update.btnSubmit`) }}
                            </button>

                            <!-- finalize manager review -->

                            <button
                                v-show="
                                    mState.contributor === 1 &&
                                        role === 'manager' &&
                                        currentUserIsContributor
                                "
                                class="btn btn-primary btn-raised tw-w-1/2"
                                style="margin-top: 5px"
                                @click="updateParticipantStatus('complete', 'private', false)"
                            >
                                {{ $t(`reviews.update.btnSubmit`) }}
                            </button>

                            <!-- share manager review  -->

                            <button
                                v-show="
                                    mState.contributor === 2 &&
                                        role === 'manager' &&
                                        currentUserIsContributor &&
                                        reviewCycle.contributorsComplete &&
                                        reviewCycle.visibility.reviewManager.result.reviewee !==
                                            'no'
                                "
                                class="btn btn-primary btn-raised tw-w-1/2"
                                style="margin-top: 5px"
                                @click="updateParticipantStatus('complete', 'shared', false)"
                            >
                                {{ $t(`reviews.update.btnShare`) }}
                            </button>

                            <!-- share manager review (contributors not complete yet) -->

                            <button
                                v-show="
                                    mState.contributor === 2 &&
                                        role === 'manager' &&
                                        currentUserIsContributor &&
                                        !reviewCycle.contributorsComplete &&
                                        reviewCycle.visibility.reviewManager.result.reviewee !==
                                            'no'
                                "
                                v-b-popover.hover.top="
                                    $t(`reviews.update.helpShareContributorsIncomplete`)
                                "
                                class="btn btn-primary btn-raised tw-w-1/2"
                                style="margin-top: 5px"
                                @click="updateParticipantStatus('complete', 'shared', false)"
                            >
                                <i class="fal fa-exclamation-triangle"></i>
                                {{ $t(`reviews.update.btnShare`) }}
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    v-if="showAlmostDoneHint"
                    data-test-id="review-progress-hint"
                    class="tw-animate-bounce tw-transition-opacity tw-duration-500 tw-absolute tw-bottom-full tw-right-4 tw-p-2 tw-rounded tw-bg-white tw-text-center tw-mb-4 tw-whitespace-nowrap tw-opacity-90"
                >
                    <template>
                        {{ $t("surveys.participate.almostDoneHint") }}
                        <span class="tw-ml-1" role="img" aria-label="party">&#127881;</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import htmlToPdfmake from "html-to-pdfmake";
import FileSaver from "file-saver";

import api from "@/api";

import format from "@/utils/format-typeahead";

import LCardContent from "@/components/LCardContent";
import LChart from "@/components/LChart";
import LInputText from "@/components/LInputText";
import LInputTypeahead from "@/components/LInputTypeahead";
import LProfilePicture from "@/components/LProfilePicture";
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";
import LRichTextEditor from "@/components/LRichTextEditor";

import LReviewsUpdateContextPanel from "@/components/LReviewsUpdateContextPanel";
import LReviewsUpdatePeerNominations from "@/components/LReviewsUpdatePeerNominations";
import LReviewsUpdatePeerSelfNominations from "@/components/LReviewsUpdatePeerSelfNominations";
import LFeedbackScale from "@/components/LFeedbackScale";
import LConfirmationModal from "@/components/LConfirmationModal.vue";

import { updateZendeskWidgetSettings } from "@/utils/zendesk-web-widget";

export default {
    components: {
        LCardContent,
        LChart,
        LInputText,
        LInputTypeahead,
        LConfirmationModal,
        LProfilePicture,
        LSpace,
        LText,
        LRichTextEditor,

        LReviewsUpdateContextPanel,
        LReviewsUpdatePeerNominations,
        LReviewsUpdatePeerSelfNominations,
        LFeedbackScale,
    },
    props: {
        reviewCycleId: {
            type: String,
            required: true,
        },
        revieweeId: {
            type: String,
            required: true,
        },
        role: {
            type: String,
            required: true,
        },
        contributorId: {
            type: String,
            required: true,
        },
        viewAs: {
            type: String,
            required: true,
        },
        view: {
            type: String,
            required: true,
        },
        entrypoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            confirmationModal: {
                show: false,
                title: "",
                text: "",
                labelConfirm: "",
                labelCancel: null,
                image: "",
                confirm: () => {},
                cancel: () => {},
            },

            reviewCycle: {},

            peerSelfSelected: false,
            peerSelfNomination: "",
            peerSelfNominationSuccess: false,

            peerMessage: "",
            peersUpdated: false,

            expandAllEnabled: false,

            index: 0,

            showAccessHolders: false,
            showDeclineForm: false,
            showDeclinedRequests: false,
            showAutoSaving: false,

            peerDeclineMessage: "",

            markIncompleteQuestions: false,

            updatingAccessHolders: false,

            error: null,

            query: {},
            reportChartStyle: "",
            graphSettings: {},
            isChartLoading: true,

            unsavedInput: false,

            isPresentationModeEnabled: false,
            showAlmostDoneHintComplete: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            accessDenied: "reviews/participants/accessDenied",
            redirect: "reviews/participants/redirect",
            getReviewCycle: "reviews/participants/details",
            usersSearchList: "users/search/list",
            localTeams: "teams/local/listSortedByName",
            getCustomRoles: "teams/customrole/list",
            report: "reviews/analytics/report",
        }),

        canEdit() {
            if (
                [2, 3].includes(this.mState.contributor) &&
                this.viewAs === "manager" &&
                this.mState.global !== 8 &&
                this.reviewCycle.contributorDetails &&
                !this.reviewCycle.contributorDetails.signatureManager &&
                !this.reviewCycle.contributorDetails.signatureReviewee &&
                this.currentUserIsContributor
            ) {
                // manager edits
                return true;
            } else if (
                [2, 3].includes(this.mState.contributor) &&
                this.viewAs === "reviewee" &&
                this.mState.global < 8 &&
                !this.reviewCycle.reviewManagerComplete
            ) {
                // reviewee edits
                return true;
            } else if (
                [2, 3].includes(this.mState.contributor) &&
                ["peer", "directReport", "additionalManager"].includes(this.viewAs) &&
                this.mState.global < 8 &&
                this.reviewCycle.contributorDetails &&
                !this.reviewCycle.contributorDetails.signatureManager
            ) {
                // edits by other roles
                return true;
            } else {
                return false;
            }
        },

        canShare() {
            return (
                this.mState.contributor === 1 &&
                this.role === "manager" &&
                this.currentUserIsContributor &&
                this.reviewCycle?.visibilityShared?.html?.length
            );
        },

        filteredFeedbackSignals() {
            if (!Array.isArray(this.reviewCycle.feedbackSignals)) return [];
            if (!this.isPresentationModeEnabled) return this.reviewCycle.feedbackSignals;

            return this.reviewCycle.feedbackSignals.filter(signal => !signal.private);
        },

        currentUserIsContributor() {
            return this.user._id === this.contributorId && this.viewAs !== "owner" ? true : false;
        },

        displayCurrentViewer() {
            return (
                this.viewAs === this.role &&
                ((this.viewAs === "reviewee" && this.reviewCycle.selfEvaluationsEnabled) ||
                    (this.viewAs === "directReport" &&
                        this.reviewCycle.directReportReviewsEnabled) ||
                    (this.viewAs === "peer" && this.reviewCycle.peerReviewsEnabled) ||
                    ((this.viewAs === "manager" || this.viewAs === "additionalManager") &&
                        this.reviewCycle.managerReviewsEnabled))
            );
        },

        progress() {
            var answered = 0;
            var count = 0;
            var progress = 0;
            var answeredMandatory = 0;
            var countMandatory = 0;
            var progressMandatory = 0;

            // skip if no feedbacksignals provided

            if (!this.reviewCycle.feedbackSignals) return { total: 0, mandatory: 0 };

            // loop through signals to extract ratings

            this.reviewCycle.feedbackSignals.forEach(function(signal) {
                if (signal.skilltype === "reviewSection") {
                    return;
                }

                if (signal.applicableToRole) {
                    count += 1;
                }

                // increase "answered" counter

                if (
                    signal.applicableToRole &&
                    // score selected
                    ((signal.ratingRequirement !== "hidden" && signal.amount > -100) ||
                        // comment provided
                        (signal.commentRequirement !== "hidden" && signal.content !== "") ||
                        // option selected
                        (signal.answerType === "multipleChoice" &&
                            signal.multipleChoiceOptions.some(function(option) {
                                return option.selected;
                            })))
                ) {
                    answered += 1;
                }

                // increase mandatory counter

                if (
                    signal.applicableToRole &&
                    (signal.ratingRequirement === "required" ||
                        signal.commentRequirement === "required" ||
                        signal.answerType === "multipleChoice")
                ) {
                    countMandatory += 1;
                }

                // increase mandatory answered

                if (
                    signal.applicableToRole &&
                    signal.ratingRequirement === "required" &&
                    signal.amount > -100 &&
                    signal.commentRequirement === "required" &&
                    signal.content !== ""
                ) {
                    answeredMandatory += 1;
                } else if (
                    signal.applicableToRole &&
                    signal.ratingRequirement === "required" &&
                    signal.amount > -100 &&
                    signal.commentRequirement !== "required"
                ) {
                    answeredMandatory += 1;
                } else if (
                    signal.applicableToRole &&
                    signal.commentRequirement === "required" &&
                    signal.content !== "" &&
                    signal.ratingRequirement !== "required"
                ) {
                    answeredMandatory += 1;
                } else if (
                    signal.applicableToRole &&
                    signal.answerType === "multipleChoice" &&
                    signal.multipleChoiceOptions.some(function(option) {
                        return option.selected;
                    })
                ) {
                    answeredMandatory += 1;
                }
            });

            // calculate progress

            progress = Math.round((answered / count) * 100);

            if (countMandatory)
                progressMandatory = Math.round((answeredMandatory / countMandatory) * 100);
            else progressMandatory = 100;

            return { total: progress, mandatory: progressMandatory };
        },

        mState() {
            // mapped

            var mGlobal = 0;
            var mContributor = 0;

            // unmapped

            var umGlobal = this.reviewCycle.status ? this.reviewCycle.status.globalStatus : "none";
            var umContributor = this.reviewCycle.contributorDetails
                ? this.reviewCycle.contributorDetails.status
                : "none";

            // visibility

            var umVisibilityC = this.reviewCycle.contributorDetails
                ? this.reviewCycle.contributorDetails.visibility
                : "none";

            // let's map

            if (umGlobal === "canceled") mGlobal = 0;
            else if (umGlobal === "draft") mGlobal = 1;
            else if (umGlobal === "new") mGlobal = 2;
            else if (umGlobal === "peerNominationsPending") mGlobal = 3;
            else if (umGlobal === "peerApprovalPending") mGlobal = 4;
            else if (umGlobal === "peerReviewsPending") mGlobal = 5;
            else if (umGlobal === "managerReviewsPending") mGlobal = 6;
            else if (umGlobal === "conversationsPending") mGlobal = 7;
            else if (umGlobal === "complete") mGlobal = 8;

            if (umContributor === "pending") mContributor = 1;
            else if (umContributor === "complete" && umVisibilityC === "private") mContributor = 2;
            else if (umContributor === "complete") mContributor = 3;

            return {
                global: mGlobal,
                contributor: mContributor,
            };
        },

        users() {
            return this.usersSearchList
                .filter(user => user._id !== this.user._id)
                .map(format.users);
        },

        col1() {
            if (this.reviewCycle.contributors.count < 3) {
                return "col-md-9 ellipse-text";
            } else if (this.reviewCycle.contributors.count < 6) {
                return "col-md-8 ellipse-text";
            } else if (this.reviewCycle.contributors.count < 9) {
                return "col-md-6 ellipse-text";
            } else if (this.reviewCycle.contributors.count >= 9) {
                return "col-md-5 ellipse-text";
            }
            return "";
        },
        col1max() {
            if (this.reviewCycle.contributors.count < 3) {
                return "col-md-9 ellipse-text";
            } else if (this.reviewCycle.contributors.count < 6) {
                return "col-md-8 ellipse-text";
            } else if (this.reviewCycle.contributors.count < 9) {
                return "col-md-6 ellipse-text";
            } else if (this.reviewCycle.contributors.count >= 9) {
                return "col-md-5 ellipse-text";
            }
            return "";
        },
        col2() {
            if (this.reviewCycle.contributors.count < 3) {
                return "col-md-3";
            } else if (this.reviewCycle.contributors.count < 6) {
                return "col-md-4";
            } else if (this.reviewCycle.contributors.count < 9) {
                return "col-md-6";
            } else if (this.reviewCycle.contributors.count >= 9) {
                return "col-md-7";
            }
            return "";
        },

        customRolesObj() {
            const customRoles = this.getCustomRoles;
            const customRolesObj = {};

            for (var i = 0; i < customRoles.length; ++i) {
                if (customRoles[i] !== undefined)
                    customRolesObj[customRoles[i]._id] = customRoles[i];
            }

            return customRolesObj;
        },

        statsManager() {
            // will be calculated live for manager, otherwise taken from backend

            if (this.role === "manager" && this.viewAs === "manager") {
                return this.calculateStats();
            } else if (this.viewAs !== "selfNomination" && this.reviewCycle.statsManager) {
                return this.reviewCycle.statsManager;
            } else {
                return { avg: 0 };
            }
        },

        dataSnapshot() {
            if (!this.report?.results?.graph) {
                return { labels: [], datasets: [] };
            }

            return {
                labels: Array.from(this.report.results.graph.labels),
                datasets: Array.from(this.report.results.graph.results).map((data, index) => ({
                    label: this.graphSettings.series?.[index],
                    data: Array.from(data),
                    ...this.graphSettings.datasetOverride?.[
                        index % this.graphSettings.datasetOverride?.length
                    ],
                })),
            };
        },
        dataHorizontalBar() {
            if (!this.report?.results?.graph) {
                return { labels: [], datasets: [] };
            }

            return {
                labels: Array.from(this.report.results.graph.labels),
                datasets: Array.from(this.graphSettings.series).map((label, index) => ({
                    label,
                    data: Array.from(this.report.results.graph.results[index]),
                    borderWidth: 1,
                    ...this.graphSettings.datasetOverride?.[index],
                })),
            };
        },

        showAlmostDoneHint() {
            if (this.mState.contributor !== 1 || this.showAlmostDoneHintComplete) {
                return false;
            }

            const isEnabled = this.progress.mandatory > 80;

            if (isEnabled) this.triggerHintTimer();

            return isEnabled;
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.reviewCycle = this.getReviewCycle(this.reviewCycleId);

                this.getReport(null, "skill", "radar").then(() => {
                    this.isChartLoading = false;
                });

                this.setStatus(this.role, this.viewAs);
            },
        },
        redirect: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.$store
                        .dispatch({
                            type: "reviews/participants/getStatus",
                            payload: {
                                reviewCycleId: val.reviewCycleId,
                                revieweeId: val.revieweeId,
                                role: val.role,
                                contributorId: val.contributorId,
                                viewAs: val.viewAs,
                                view: val.view,
                                entrypoint: val.entrypoint,
                            },
                        })
                        .then(() => {
                            this.$router.replace(
                                `/reviews/update/${val.reviewCycleId}/reviewee/${val.revieweeId}/${val.role}/${val.contributorId}/viewAs/${val.viewAs}/${val.view}/${val.entrypoint}`,
                            );
                        });
                }
            },
        },
    },

    mounted() {
        // hide 3rd party widgets
        this.disableExternalWidget();
    },
    beforeDestroy() {
        // re-enable any 3rd party widgets
        this.enableExternalWidget();
    },

    methods: {
        triggerHintTimer() {
            setTimeout(() => {
                this.showAlmostDoneHintComplete = true;
            }, 4.5 * 1000);
        },
        enableExternalWidget() {
            updateZendeskWidgetSettings({ suppress: false, zIndex: 999999 });
        },
        disableExternalWidget() {
            updateZendeskWidgetSettings({ suppress: true, zIndex: 40 });
        },
        goBack() {
            this.$router.go(-1);
        },
        updateAmount({ feedbackSignalIndex, amount }) {
            this.reviewCycle.feedbackSignals[feedbackSignalIndex].amount = amount;
            this.autoSave();
        },
        calculateStats() {
            // calculated for all review types

            var stats = {
                company: 0,
                cCompany: 0,
                teams: 0,
                cTeams: 0,
                goals: 0,
                cGoals: 0,
                goalsWeightTotal: 0,
                questions: 0,
                cQuestions: 0,
                avg: 0,
                count: 0,
            };

            // adjust for scale

            var scaleDivider;
            var scaleAdjustment = 1;

            switch (this.reviewCycle.scale && this.reviewCycle.scale.type) {
                case "7":
                    scaleDivider = 16;
                    break;
                case "6":
                    scaleDivider = 20;
                    break;
                case "5":
                    scaleDivider = 25;
                    break;
                case "4":
                    scaleDivider = 33;
                    break;
                case "3":
                    scaleDivider = 50;
                    break;
                case "2":
                    scaleDivider = 100;
                    break;
                case "100":
                    scaleDivider = 1;
                    scaleAdjustment = 0;
            }
            // this mean we have question using different scale
            if (this.reviewCycle.mixedScale) {
                scaleDivider = 1;
                scaleAdjustment = 0;
                // we want to make sure the rating is normalized to 100
            }

            // skip if no feedbacksignals provided

            if (!this.reviewCycle.feedbackSignals) return stats;

            // 1st loop to calculate goal weights - we won't do be able goals with and without weights

            this.reviewCycle.feedbackSignals.forEach(signal => {
                if (signal.skilltype === "goalUser") {
                    stats.goalsWeightTotal +=
                        signal.weight === 0 || signal.weight > 0 ? signal.weight : 100;
                }
            });

            // loop through signals to establish category weights

            this.reviewCycle.feedbackSignals.forEach(signal => {
                var individualWeight;

                var scaledAvg = signal.amount / scaleDivider + scaleAdjustment;

                // skip incomplete / unstructured / optional questions

                if (typeof signal.amount === "undefined" || signal.amount < 0) {
                    return;
                }

                if (!this.reviewCycle.questions.customScoresEnabled) {
                    // no custom scores or weights, all questions will be weighed equally

                    stats.questions += scaledAvg;
                    stats.cQuestions++;
                } else if (
                    signal.skilltype === "team" &&
                    this.reviewCycle.questions.companySkills.enabled
                ) {
                    // prepare generall skill average

                    stats.company += scaledAvg;
                    stats.cCompany++;
                } else if (
                    signal.skilltype === "localTeam" &&
                    this.reviewCycle.questions.teamSkills.enabled
                ) {
                    // prepare team skill average

                    stats.teams += scaledAvg;
                    stats.cTeams++;
                } else if (signal.skilltype === "goalUser") {
                    // prepare goal average

                    individualWeight =
                        (signal.weight === 0 || signal.weight > 0 ? signal.weight : 100) /
                        stats.goalsWeightTotal;

                    stats.goals += individualWeight * scaledAvg;
                    stats.cGoals++;
                } else if (
                    this.reviewCycle.questions.settings[signal.skill] &&
                    typeof this.reviewCycle.questions.settings[signal.skill].weight !== "undefined"
                ) {
                    // custom score -> prepare question average

                    individualWeight =
                        this.reviewCycle.questions.settings[signal.skill].weight / 100;
                    stats.questions += individualWeight * scaledAvg;
                    stats.cQuestions++;
                }
            });

            // weights

            stats.avg = 0;

            if (stats.cCompany) {
                stats.company = (stats.company / stats.cCompany).toFixed(1);
                stats.avg +=
                    stats.company *
                    (typeof this.reviewCycle.questions.companySkills.weight !== "undefined"
                        ? this.reviewCycle.questions.companySkills.weight / 100
                        : 1);
            }

            if (stats.cTeams) {
                stats.teams = (stats.teams / stats.cTeams).toFixed(1);
                stats.avg +=
                    stats.teams *
                    (typeof this.reviewCycle.questions.teamSkills.weight !== "undefined"
                        ? this.reviewCycle.questions.teamSkills.weight / 100
                        : 1);
            }

            if (stats.cGoals) {
                stats.goals = stats.goals.toFixed(1); // already weighted
                stats.avg +=
                    stats.goals *
                    (typeof this.reviewCycle.questions.goals.weight !== "undefined"
                        ? this.reviewCycle.questions.goals.weight / 100
                        : 1);
            }

            if (stats.cQuestions && !this.reviewCycle.questions.customScoresEnabled) {
                stats.questions = stats.questions / stats.cQuestions;
                stats.avg = stats.questions;
            } else {
                stats.avg += stats.questions; // already weighted
            }

            stats.avg = stats.avg.toFixed(1);

            return stats;
        },

        async reviewCycleUpdate(opts) {
            await this.$store.dispatch({
                type: "reviews/participants/getStatus",
                payload: {
                    reviewCycleId: opts.reviewCycleId,
                    revieweeId: opts.revieweeId,
                    role: opts.role,
                    contributorId: opts.contributorId,
                    viewAs: opts.viewAs,
                    view: opts.view,
                    entrypoint: opts.entrypoint,
                },
            });

            this.$router.push(
                `/reviews/update/${opts.reviewCycleId}/reviewee/${opts.revieweeId}/${opts.role}/${opts.contributorId}/viewAs/${opts.viewAs}/${opts.view}/${opts.entrypoint}`,
            );

            this.reviewCycle = this.getReviewCycle(opts.reviewCycleId);

            this.getReport(null, "skill", "radar").then(() => {
                this.isChartLoading = false;
            });

            this.setStatus(this.role, this.viewAs);
        },

        expandAll() {
            this.reviewCycle.feedbackSignals.forEach((_, index) => {
                this.$set(this.reviewCycle.feedbackSignals[index], "expanded", true);
            });

            this.expandAllEnabled = true;
        },

        showOverview() {
            this.index = 0;

            this.reviewCycle.feedbackSignals.forEach((_, index) => {
                this.$set(this.reviewCycle.feedbackSignals[index], "expanded", false);
            });

            this.expandAllEnabled = false;
        },

        generatePDF() {
            const feedbackSignals = Array.from(this.filteredFeedbackSignals) || [];
            const skills = this.reviewCycle.questions?.skills?.reduce?.((obj, skill) => {
                if (skill?._id) {
                    obj[skill._id] = skill;
                }

                return obj;
            }, {});

            const dd = {
                pageSize: "A4",
                footer: (currentPage, pageCount) => ({
                    text: `${currentPage} / ${pageCount}`,
                    style: "footer",
                }),
                pageMargins: [50, 50, 50, 50],
                content: [
                    {
                        text: `Review: ${this.reviewCycle.revieweeUser.firstname} ${this.reviewCycle.revieweeUser.lastname}`,
                        style: "header",
                    },
                    { text: this.reviewCycle.name, style: "subHeader" },
                ],
                styles: {
                    header: {
                        fontSize: 22,
                        color: "#4285F4",
                        margin: [0, 20, 0, 10],
                    },
                    subHeader: {
                        fontSize: 16,
                        color: "#b2b2b2",
                        bold: false,
                        margin: [0, 0, 0, 20],
                    },
                    question: {
                        pageBreak: "before",
                        fontSize: 13,
                        bold: true,
                        margin: [0, 0, 0, 15],
                    },
                    questionDetails: {
                        fontSize: 12,
                        italics: true,
                        color: "#777777",
                        margin: [0, 0, 0, 15],
                    },
                    answer: {
                        fontSize: 12,
                        margin: [20, 0, 0, 15],
                    },
                    name: {
                        bold: true,
                        fontSize: 12,
                        color: "#666666",
                        margin: [20, 0, 0, 10],
                    },
                    line: {
                        color: "#f2f2f2",
                        fontSize: 16,
                        margin: [0, 0, 0, 15],
                    },
                    footer: {
                        color: "#c3c3c3",
                        fontSize: 10,
                        alignment: "center",
                        margin: [0, 15, 0, 0],
                    },
                },
            };

            if (
                this.reviewCycle.contributorDetails?.signatureReviewee ||
                this.reviewCycle.contributorDetails?.signatureManager
            ) {
                if (this.reviewCycle.contributorDetails.signatureReviewee) {
                    dd.content.push({
                        text: `Signed by ${this.reviewCycle.revieweeUser.firstname} ${this.reviewCycle.revieweeUser.lastname}`,
                        style: "name",
                    });

                    if (this.reviewCycle.contributorDetails.notesReviewee) {
                        dd.content.push({
                            text: `"${this.reviewCycle.contributorDetails.notesReviewee}"`,
                            style: "answer",
                        });
                    }
                }

                if (
                    this.reviewCycle.contributorDetails.signatureManager &&
                    this.reviewCycle.managerUser
                ) {
                    dd.content.push({
                        text: `Signed by ${this.reviewCycle.managerUser.firstname} ${this.reviewCycle.managerUser.lastname}`,
                        style: "name",
                    });

                    if (this.reviewCycle.contributorDetails.notesManager) {
                        dd.content.push({
                            text: `"${this.reviewCycle.contributorDetails.notesManager}"`,
                            style: "answer",
                        });
                    }
                }
            }

            feedbackSignals.forEach(question => {
                if (!question.skillname) {
                    return;
                }

                // question title and description

                dd.content.push({
                    text: "____________________________________________________",
                    style: "line",
                });

                if (skills[question.skill].categoryName) {
                    dd.content.push({
                        text: `${skills[question.skill].categoryName}: ${question.skillname} ${
                            question.private ? `[${this.$t("analytics.labelPrivate")}]` : ""
                        }`,
                        style: "question",
                    });
                } else {
                    dd.content.push({
                        text: `${question.skillname} ${
                            question.private ? `[${this.$t("analytics.labelPrivate")}]` : ""
                        }`,
                        style: "question",
                    });
                }

                if (question.skilldescription) {
                    dd.content.push({
                        text: question.skilldescription,
                        style: "questionDetails",
                    });
                }

                // current contributor answer
                const details = this.reviewCycle.contributorDetails;

                if (details.user && details.answers && details.answers[question.skill]) {
                    if (
                        details.answers[question.skill].amount >= 0 &&
                        question.fScale[details.answers[question.skill].amount]
                    ) {
                        const data = {
                            text: "",
                            style: "name",
                        };

                        if (question.scale.type === "100") {
                            // TODO: Temporary solution, long-term we'll look into providing a
                            // colorized bar similar to what one sees within the web UI
                            data.text = `${details.user.firstname} ${details.user.lastname}: ${
                                details.answers[question.skill].amount
                            } / ${question.scale.type}`;
                        } else if (question.scale.hideNumbers) {
                            data.text = `${details.user.firstname} ${details.user.lastname}: ${
                                question.fScale[details.answers[question.skill].amount].label
                            }`;
                        } else {
                            data.text = `${details.user.firstname} ${details.user.lastname}: ${
                                question.fScale[details.answers[question.skill].amount].point
                            } / ${question.scale.type}`;
                        }

                        dd.content.push(data);
                    } else {
                        dd.content.push({
                            text: `${details.user.firstname} ${details.user.lastname}`,
                            style: "name",
                        });
                    }

                    if (details.answers[question.skill].content) {
                        let text = details.answers[question.skill].content;

                        text = htmlToPdfmake(text);

                        dd.content.push({
                            stack: Array.isArray(text) ? text : [text],
                            style: "answer",
                        });
                    }

                    if (details.answers[question.skill].answers && question.multipleChoiceOptions) {
                        question.multipleChoiceOptions.forEach(function(o) {
                            if (o.selected) {
                                dd.content.push({
                                    text: "[ X ] " + o.title,
                                    style: "answer",
                                });
                            }
                        });
                    }
                }

                // other contributors

                if (this.reviewCycle.contributors.all && this.reviewCycle.contributors.all.length) {
                    this.reviewCycle.contributors.all.forEach(contributor => {
                        if (contributor.answers && contributor.answers[question.skill]) {
                            if (
                                contributor.answers[question.skill].amount >= 0 &&
                                question.fScale[contributor.answers[question.skill].amount]
                            ) {
                                const data = {
                                    text: "",
                                    style: "name",
                                };

                                if (question.scale.type === "100") {
                                    // TODO: Temporary solution, long-term we'll look into providing a
                                    // colorized bar similar to what one sees within the web UI
                                    data.text = `${contributor.label}: ${
                                        contributor.answers[question.skill].amount
                                    } / ${question.scale.type}`;
                                } else if (question.scale.hideNumbers) {
                                    data.text = `${contributor.label}: ${
                                        question.fScale[contributor.answers[question.skill].amount]
                                            .label
                                    }`;
                                } else {
                                    data.text = `${contributor.label}: ${
                                        question.fScale[contributor.answers[question.skill].amount]
                                            .point
                                    } / ${question.scale.type}`;
                                }

                                dd.content.push(data);
                            } else {
                                dd.content.push({
                                    text: contributor.label,
                                    style: "name",
                                });
                            }

                            if (contributor.answers[question.skill].content) {
                                const text = htmlToPdfmake(
                                    contributor.answers[question.skill].content,
                                );
                                dd.content.push({
                                    stack: Array.isArray(text) ? text : [text],
                                    style: "answer",
                                });
                            }

                            if (
                                contributor.answers[question.skill].answers &&
                                question.multipleChoiceOptions
                            ) {
                                question.multipleChoiceOptions.forEach(function(o) {
                                    if (
                                        contributor.answers[question.skill].answers.indexOf(o._id) >
                                        -1
                                    ) {
                                        dd.content.push({
                                            text: "[ X ] " + o.title,
                                            style: "answer",
                                        });
                                    }
                                });
                            }
                        }
                    });
                }
            });

            return api
                .post(
                    "/api/reviewcycles/pdf",
                    { dd },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/pdf",
                        },
                        responseType: "arraybuffer",
                    },
                )
                .then(response => {
                    const filename =
                        "Review_" +
                        this.reviewCycle.revieweeUser.firstname +
                        this.reviewCycle.revieweeUser.lastname +
                        ".pdf";

                    /* the saveAs call downloads a file on the local machine */
                    FileSaver.saveAs(
                        new Blob([response.data], {
                            type: "application/pdf;",
                        }),
                        filename,
                    );
                });
        },

        async updateParticipantStatus(status, visibility, signature, notes) {
            if (status === "complete") {
                // force-save to prevent losing information if auto-save wasn't triggered

                await this.saveFeedback(status);
            }

            if (status === "complete" && this.progress.mandatory < 100) {
                this.markIncompleteQuestions = true;

                this.confirmationModal = {
                    show: true,
                    title: this.$t("reviews.update.notCompleteTitle"),
                    text: this.$t("reviews.update.notCompleteText"),
                    labelConfirm: this.$t("reviews.update.notCompleteBtn"),
                    showCancel: false,
                    image: "/img/icons/conversation.png",
                    confirm: () => {
                        this.confirmationModal.show = false;
                    },
                    cancel: () => {
                        this.confirmationModal.show = false;
                    },
                };

                return;
            }

            // udpate the status

            await this.$store.dispatch({
                type: "reviews/participants/updateStatus",
                payload: {
                    reviewCycleId: this.reviewCycle._id,
                    contributorRole: this.role,
                    reviewee: this.reviewCycle.revieweeUser?._id,
                    contributorStatus: status,
                    visibility,
                    signature,
                    ratingStats: this.calculateStats(),
                    notes,
                },
            });

            if (!this.reviewCycle.contributorDetails) {
                this.reviewCycle.contributorDetails = {};
            }

            if (this.viewAs === "reviewee" && signature)
                this.reviewCycle.contributorDetails.signatureReviewee = Date.now();

            if (this.viewAs === "reviewee" && notes)
                this.reviewCycle.contributorDetails.notesReviewee = notes;

            if (this.viewAs === "manager" && signature)
                this.reviewCycle.contributorDetails.signatureManager = Date.now();

            if (this.viewAs === "manager" && notes)
                this.reviewCycle.contributorDetails.notesManager = notes;

            if (status === "pending") {
                this.showOverview();
            }

            // update states (redirect to selfassessment for reviewee)

            if (status === "complete" && visibility !== "shared") {
                // completing: we need to check whether manager can share

                this.confirmationModal = {
                    show: true,
                    title: this.canShare
                        ? this.$t("reviews.update.shareNowTitle")
                        : this.$t("reviews.update.submitTitle"),
                    text: this.canShare
                        ? this.$t("reviews.update.shareNowText")
                        : this.$t("reviews.update.submitText"),
                    labelCancel: this.$t("reviews.update.btnShareLater"),
                    showCancel: this.canShare,
                    labelConfirm: this.canShare
                        ? this.$t("reviews.update.btnShareNow")
                        : this.$t("reviews.update.submitCongratsModalBtnText"),
                    image: "/img/icons/progress.png",
                    confirm: async () => {
                        if (this.canShare) {
                            // confirm is triggered if manager decides to share in same step

                            await this.$store.dispatch({
                                type: "reviews/participants/updateStatus",
                                payload: {
                                    reviewCycleId: this.reviewCycle._id,
                                    contributorRole: this.role,
                                    reviewee: this.reviewCycle.revieweeUser?._id,
                                    contributorStatus: "complete",
                                    visibility: "shared",
                                    signature,
                                    ratingStats: this.calculateStats(),
                                    notes,
                                },
                            });
                        }

                        await this.reloadStatus();
                    },
                    cancel: async () => {
                        await this.reloadStatus();
                    },
                };
            } else if (status === "complete" && visibility === "shared") {
                // sharing: only managers can do this

                this.confirmationModal = {
                    show: true,
                    title: this.$t("reviews.update.shareCongratsModalTitle"),
                    text: this.$t("reviews.update.shareCongratsModalText"),
                    labelConfirm: this.$t("reviews.update.shareCongratsModalBtnText"),
                    showCancel: false,
                    image: "/img/icons/conversation.png",
                    confirm: async () => {
                        await this.reloadStatus();
                    },
                    cancel: async () => {
                        await this.reloadStatus();
                    },
                };
            } else {
                await this.reloadStatus();
            }
        },

        async reloadStatus() {
            window.scrollTo({ top: 0 });

            this.confirmationModal.show = false;

            await this.$store.dispatch({
                type: "reviews/participants/getStatus",
                payload: {
                    reviewCycleId: this.reviewCycleId,
                    revieweeId: this.revieweeId,
                    role: this.role,
                    contributorId: this.contributorId,
                    viewAs: this.viewAs,
                    view: this.view,
                    entrypoint: this.entrypoint,
                },
            });

            this.reviewCycle = this.getReviewCycle(this.reviewCycleId);

            await this.getReport(null, "skill", "radar");

            this.isChartLoading = false;
            this.setStatus(this.role, this.viewAs);

            this.$forceUpdate();
        },

        async saveFeedback(status) {
            // prepare other input

            var requestData = {
                feedbackSet: this.reviewCycle.feedbackSet,
                feedbackSignals: this.reviewCycle.feedbackSignals,
                reviewCycle: this.reviewCycle._id,
                receiver: this.reviewCycle.receiver,
                type: this.reviewCycle.type,
                updateExisting: true,
                status,
            };

            // call API to save feedback

            // Important: the no-auth flag leads to different route and handles survey answers

            await this.$store.dispatch({
                type: "reviews/participants/saveFeedback",
                payload: { requestData },
            });
        },

        declinePeerRequest() {
            if (!this.peerDeclineMessage || this.peerDeclineMessage.length < 3) {
                this.error = true;
                return;
            } else {
                this.error = false;
            }

            this.$store
                .dispatch({
                    type: "reviews/participants/updateStatus",
                    payload: {
                        reviewCycleId: this.reviewCycle._id,
                        contributorRole: "peer",
                        reviewee: this.reviewCycle.revieweeUser?._id,
                        contributorStatus: "declined",
                        visibility: "private",
                        signature: false,
                        notes: null,
                        peerDeclineMessage: this.peerDeclineMessage,
                    },
                })
                .then(() => {
                    this.$router.push(`/reviews`);
                })
                .catch(() => {
                    this.error = true;
                });
        },

        addAccessHolder(user) {
            // create arrays if they don't exist

            if (!this.reviewCycle.accessHolders) this.reviewCycle.accessHolders = [];

            // check whether already present

            if (this.reviewCycle.accessHolders.find(ah => ah._id === user._id)) return;

            // add to array

            this.reviewCycle.accessHolders.push({
                _id: user._id,
                fullname: user.fullname,
            });

            this.$store.dispatch("users/search/reset");
        },
        updateAccessHolders() {
            this.updatingAccessHolders = true;

            // call API

            this.$store
                .dispatch({
                    type: "reviews/participants/updateAccessHolders",
                    payload: {
                        reviewCycle: this.reviewCycle._id,
                        reviewee: this.reviewCycle.revieweeUser?._id,
                        accessHolders: this.reviewCycle.accessHolders,
                    },
                })
                .finally(() => {
                    this.updatingAccessHolders = false;
                });
        },
        removeAccessHolder(index) {
            this.reviewCycle.accessHolders.splice(index, 1);
        },
        typeaheadAccessHolderOnInput(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },

        showNextSkill(direction, newIndex, autoForward) {
            // hide / show question

            this.$set(
                this.reviewCycle.feedbackSignals[newIndex],
                "expanded",
                !this.reviewCycle.feedbackSignals[newIndex].expanded,
            );

            // if accessing as contributor while writing review ...

            if (this.mState.contributor === 1 && this.viewAs !== "owner") {
                // validate before changing question (user is trying to move to different skill)

                if (this.unsavedInput && !this.validateAnswer()) return;

                // save (includes second validation)

                this.saveFeedbackSignals(true, true);

                // reset error

                this.error = null;
            }

            // update factory

            if (this.progress.total === 100 && autoForward) {
                // autoforward, all answered  -> back to overview

                this.showOverview();
                return;
            } else if (newIndex >= this.reviewCycle.feedbackSignals.length && autoForward) {
                // autoforward, end reached -> go to first unanswered

                this.index = 1;
            } else if (
                this.mState.contributor === 1 &&
                this.viewAs !== "owner" &&
                this.reviewCycle.feedbackSignals[newIndex].applicableToRole
            ) {
                // autoforward, user is contributor -> go to next open

                this.index = newIndex;
            } else {
                // view only -> scroll to question

                this.index = newIndex;

                this.scrollQuestionIntoView(newIndex);
            }
        },

        validateAnswer() {
            if (!this.reviewCycle.questions.settings) return true;

            if (
                this.reviewCycle.feedbackSignals[this.index].ratingRequirement === "optional" &&
                this.reviewCycle.feedbackSignals[this.index].commentRequirement === "optional"
            ) {
                // allow to skip if both comment and rating are optional

                return true;
            }

            if (
                this.reviewCycle.feedbackSignals[this.index].commentRequirement === "required" &&
                !this.reviewCycle.feedbackSignals[this.index].content.length
            ) {
                // unstructured questions require comment

                this.error = {
                    message: this.$t("reviews.update.answerCommentMissing"),
                };

                return false;
            } else if (
                this.reviewCycle.feedbackSignals[this.index].ratingRequirement === "required" &&
                this.reviewCycle.feedbackSignals[this.index].amount === -100
            ) {
                // structured questions require score

                this.error = { message: this.$t("reviews.update.answerScoreMissing") };

                return false;
            } else if (
                this.reviewCycle.feedbackSignals[this.index].ratingRequirement === "optional" &&
                this.reviewCycle.feedbackSignals[this.index].amount === -100
            ) {
                // optional structured questions require 'n/a' score

                this.error = {
                    message: this.$t("reviews.update.answerScoreMissingOptional"),
                };

                return false;
            } else {
                return true;
            }
        },

        scrollQuestionIntoView(newIndex) {
            // timeout is a hack!

            setTimeout(() => {
                var element = document.getElementById(
                    this.reviewCycle.feedbackSignals[newIndex].skill,
                );

                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 10);
        },

        autoSave() {
            // set flag for unsavedInput (picked up by saveFeedbackSignals)

            this.unsavedInput = true;

            this.showAutoSaving = true;

            if (this.timer) {
                // cancel previous timer
                clearTimeout(this.timer);
            }

            // set new timeout

            this.timer = setTimeout(() => {
                this.saveFeedbackSignals(true, false);
            }, 4000);
        },

        saveFeedbackSignals(autoSaving, attemptToShowNext) {
            // triggered when changing questions without saving ( -> autoSaving )
            // triggered when inactive after input ( -> autoSaving )

            // skip if autoSaving AND there's no unsavedInput

            if (!this.unsavedInput && autoSaving) return;

            // skip if attempting to change question AND answer is invalid

            if (attemptToShowNext && !this.validateAnswer()) return;

            // save feedbacksignals

            this.saveFeedback().then(() => {
                // hide icon

                this.showAutoSaving = false;

                // update status

                this.setStatus(this.role, this.viewAs);

                // reset unsavedInput flag

                this.unsavedInput = false;

                // show next skill

                if (!autoSaving) {
                    this.showNextSkill(
                        "next",
                        this.reviewCycle.feedbackSignals[this.index].feedbackSignalIndex + 1,
                        true,
                    );
                }
            });
        },

        setStatus(role, viewAs) {
            this.reviewCycle.visibilitySubmitted = { answers: [], name: [], html: "" };
            this.reviewCycle.visibilityShared = { answers: [], name: [], html: "" };

            // Visibility settings are not returned, user does not have access to this review cycle
            if (!this.reviewCycle.visibility) {
                return;
            }

            if (role === "reviewee" && viewAs === "reviewee") {
                // messages for reviewee

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleSelfEvaluation");

                // visibility for manager

                if (
                    this.reviewCycle.visibility.reviewReviewee.result.manager !== "no" &&
                    this.reviewCycle.managerUser
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForManager", {
                            firstname: this.reviewCycle.managerUser.firstname,
                            lastname: this.reviewCycle.managerUser.lastname,
                        }),
                    );

                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForAdditionalManager"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForManager"),
                    );
                }

                // visibility for owner

                if (this.reviewCycle.visibility.reviewReviewee.result.owner !== "no") {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForOwner"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForOwner"),
                    );
                }

                // no visibility for anyone else

                this.reviewCycle.visibilitySubmitted.answers.push(
                    this.$t("reviews.update.answersNotVisibleForPeer"),
                );

                this.reviewCycle.visibilitySubmitted.answers.push(
                    this.$t("reviews.update.answersNotVisibleForDirectReport"),
                );

                // not anonymous

                this.reviewCycle.visibilitySubmitted.name.push(
                    this.$t("reviews.update.nameAlwaysVisible"),
                );
            } else if (role === "manager" && viewAs === "reviewee") {
                // message for reviewee

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleManagerAsReviewee");
            } else if (role === "manager" && viewAs === "manager") {
                // messages for manager

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleManagerAsManager", {
                    firstname: this.reviewCycle.revieweeUser?.firstname,
                    lastname: this.reviewCycle.revieweeUser?.lastname,
                });

                // visibility for owner

                if (this.reviewCycle.visibility.reviewManager.result.owner !== "no") {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForOwner"),
                    );
                    this.reviewCycle.visibilitySubmitted.name.push(
                        this.$t("reviews.update.nameAlwaysVisible"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForOwner"),
                    );
                }

                // visibility for reviewee

                if (this.reviewCycle.visibility.reviewManager.result.reviewee !== "no") {
                    this.reviewCycle.visibilityShared.answers.push(
                        this.$t("reviews.update.answersVisibleForReviewee", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );

                    // no visibility for anyone else

                    this.reviewCycle.visibilityShared.answers.push(
                        this.$t("reviews.update.answersNotVisibleForPeer"),
                    );

                    this.reviewCycle.visibilityShared.answers.push(
                        this.$t("reviews.update.answersNotVisibleForDirectReport"),
                    );

                    // not anonymous

                    this.reviewCycle.visibilityShared.name.push(
                        this.$t("reviews.update.nameAlwaysVisible"),
                    );
                }
            } else if (role === "additionalManager" && viewAs === "additionalManager") {
                // messages for additional manager

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleManagerAsManager", {
                    firstname: this.reviewCycle.revieweeUser?.firstname,
                    lastname: this.reviewCycle.revieweeUser?.lastname,
                });

                // visibility for owner

                if (this.reviewCycle.visibility.reviewManager.result.owner !== "no") {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForOwner"),
                    );
                    this.reviewCycle.visibilitySubmitted.name.push(
                        this.$t("reviews.update.nameAlwaysVisible"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForOwner"),
                    );
                }

                // visibility for reviewee

                if (this.reviewCycle.visibility.reviewManager.result.reviewee !== "no") {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForRevieweeSharedByPrimaryManager", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );
                }
            } else if (role === "manager" && viewAs === "owner") {
                // message for owner

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleManagerAsOwner", {
                    firstname: this.reviewCycle.revieweeUser?.firstname,
                    lastname: this.reviewCycle.revieweeUser?.lastname,
                });
            } else if (role === "peer" && viewAs === "peer") {
                // message for peer

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titlePeer", {
                    firstname: this.reviewCycle.revieweeUser?.firstname,
                    lastname: this.reviewCycle.revieweeUser?.lastname,
                });

                // visibility for reviewee

                if (
                    this.reviewCycle.visibility.reviewPeer.result.reviewee !== "no" &&
                    this.reviewCycle.visibility.reviewPeer.name.reviewee !== "onlyAggregatedResults"
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForReviewee", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForReviewee", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );
                }

                // visibility for manager

                if (
                    this.reviewCycle.visibility.reviewPeer.result.manager !== "no" &&
                    this.reviewCycle.visibility.reviewPeer.name.manager !=
                        "onlyAggregatedResults" &&
                    this.reviewCycle.managerUser
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForManager", {
                            firstname: this.reviewCycle.managerUser.firstname,
                            lastname: this.reviewCycle.managerUser.lastname,
                        }),
                    );

                    if (
                        this.reviewCycle.visibility.reviewPeer.result.reviewee ==
                        "onceManagerShared"
                    ) {
                        this.reviewCycle.visibilitySubmitted.answers.push(
                            this.$t("reviews.update.answersSharedByManager", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                    }

                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForAdditionalManager"),
                    );
                } else if (this.reviewCycle.managerUser) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForManager", {
                            firstname: this.reviewCycle.managerUser.firstname,
                            lastname: this.reviewCycle.managerUser.lastname,
                        }),
                    );
                }

                // visibility for owner

                if (
                    this.reviewCycle.visibility.reviewPeer.result.owner !== "no" &&
                    this.reviewCycle.visibility.reviewPeer.name.owner !== "onlyAggregatedResults"
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForOwner"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForOwner"),
                    );
                }

                // anonymity

                if (this.reviewCycle.visibility.reviewPeer.result.reviewee !== "no") {
                    if (this.reviewCycle.visibility.reviewPeer.name.reviewee === "yes")
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForReviewee", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                    else
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForReviewee", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                }

                if (
                    this.reviewCycle.visibility.reviewPeer.result.manager !== "no" &&
                    this.reviewCycle.managerUser
                ) {
                    if (this.reviewCycle.visibility.reviewPeer.name.manager === "yes")
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForManager", {
                                firstname: this.reviewCycle.managerUser.firstname,
                                lastname: this.reviewCycle.managerUser.lastname,
                            }),
                        );
                    else
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForManager", {
                                firstname: this.reviewCycle.managerUser.firstname,
                                lastname: this.reviewCycle.managerUser.lastname,
                            }),
                        );
                }

                if (this.reviewCycle.visibility.reviewPeer.result.owner !== "no") {
                    if (this.reviewCycle.visibility.reviewPeer.name.owner === "yes")
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForOwner"),
                        );
                    else
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForOwner"),
                        );
                }
            } else if (role === "directReport" && viewAs === "directReport") {
                // message for direct reports

                this.reviewCycle.reviewTitle = this.$t("reviews.update.titleDirectReport", {
                    firstname: this.reviewCycle.revieweeUser?.firstname,
                    lastname: this.reviewCycle.revieweeUser?.lastname,
                });

                // visibility for reviewee

                if (
                    this.reviewCycle.visibility.reviewDirectReport.result.reviewee !== "no" &&
                    this.reviewCycle.visibility.reviewDirectReport.name.reviewee !=
                        "onlyAggregatedResults"
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForReviewee", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForReviewee", {
                            firstname: this.reviewCycle.revieweeUser?.firstname,
                            lastname: this.reviewCycle.revieweeUser?.lastname,
                        }),
                    );
                }

                // visibility for manager

                if (
                    this.reviewCycle.visibility.reviewDirectReport.result.manager !== "no" &&
                    this.reviewCycle.visibility.reviewDirectReport.name.manager !=
                        "onlyAggregatedResults" &&
                    this.reviewCycle.managerUser
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForManager", {
                            firstname: this.reviewCycle.managerUser.firstname,
                            lastname: this.reviewCycle.managerUser.lastname,
                        }),
                    );

                    if (
                        this.reviewCycle.visibility.reviewDirectReport.result.reviewee ==
                        "onceManagerShared"
                    ) {
                        this.reviewCycle.visibilitySubmitted.answers.push(
                            this.$t("reviews.update.answersSharedByManager", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                    }

                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForAdditionalManager"),
                    );
                } else if (this.reviewCycle.managerUser) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForManager", {
                            firstname: this.reviewCycle.managerUser.firstname,
                            lastname: this.reviewCycle.managerUser.lastname,
                        }),
                    );
                }

                // visibility for owner

                if (
                    this.reviewCycle.visibility.reviewDirectReport.result.owner !== "no" &&
                    this.reviewCycle.visibility.reviewDirectReport.name.owner !=
                        "onlyAggregatedResults"
                ) {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersVisibleForOwner"),
                    );
                } else {
                    this.reviewCycle.visibilitySubmitted.answers.push(
                        this.$t("reviews.update.answersNotVisibleForOwner"),
                    );
                }

                // anonymity

                if (this.reviewCycle.visibility.reviewDirectReport.result.reviewee !== "no") {
                    if (this.reviewCycle.visibility.reviewDirectReport.name.reviewee === "yes")
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForReviewee", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                    else
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForReviewee", {
                                firstname: this.reviewCycle.revieweeUser?.firstname,
                                lastname: this.reviewCycle.revieweeUser?.lastname,
                            }),
                        );
                }

                if (
                    this.reviewCycle.visibility.reviewDirectReport.result.manager !== "no" &&
                    this.reviewCycle.managerUser
                ) {
                    if (this.reviewCycle.visibility.reviewDirectReport.name.manager === "yes") {
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForManager", {
                                firstname: this.reviewCycle.managerUser.firstname,
                                lastname: this.reviewCycle.managerUser.lastname,
                            }),
                        );
                    } else if (this.reviewCycle.managerUser) {
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForManager", {
                                firstname: this.reviewCycle.managerUser.firstname,
                                lastname: this.reviewCycle.managerUser.lastname,
                            }),
                        );
                    }
                }

                if (this.reviewCycle.visibility.reviewDirectReport.result.owner !== "no") {
                    if (this.reviewCycle.visibility.reviewDirectReport.name.owner === "yes")
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameVisibleForOwner"),
                        );
                    else
                        this.reviewCycle.visibilitySubmitted.name.push(
                            this.$t("reviews.update.nameNotVisibleForOwner"),
                        );
                }
            }

            this.reviewCycle.visibilitySubmitted.answers.forEach(e => {
                this.reviewCycle.visibilitySubmitted.html += "<li>" + e + "</li>";
            });

            this.reviewCycle.visibilitySubmitted.name.forEach(e => {
                this.reviewCycle.visibilitySubmitted.html += "<li>" + e + "</li>";
            });

            this.reviewCycle.visibilityShared.answers.forEach(e => {
                this.reviewCycle.visibilityShared.html += "<li>" + e + "</li>";
            });

            this.reviewCycle.visibilityShared.name.forEach(e => {
                this.reviewCycle.visibilityShared.html += "<li>" + e + "</li>";
            });

            if (this.reviewCycle.visibilitySubmitted.html.length) {
                this.reviewCycle.visibilitySubmitted.html =
                    "<br /><ul>" + this.reviewCycle.visibilitySubmitted.html + "</ul><br />";
            }

            if (this.reviewCycle.visibilityShared.html.length) {
                this.reviewCycle.visibilityShared.html =
                    "<br /><ul>" + this.reviewCycle.visibilityShared.html + "</ul><br />";
            }
        },

        selectOption(index, option) {
            var question = this.reviewCycle.feedbackSignals[index];

            if (!question.allowMultipleAnswers) {
                // Unselect all the options ...

                question.multipleChoiceOptions.forEach(function(o) {
                    o.selected = false;
                });
            }

            // Select / unselect current option

            option.selected = option.selected ? false : true;

            // update answers array

            question.answers = question.multipleChoiceOptions
                .map(function(o) {
                    if (o.selected && o._id) {
                        return o._id;
                    }
                })
                .filter(Boolean);

            this.$set(this.reviewCycle.feedbackSignals, index, question);
        },

        async getReport(input, dimensionType, reportChartStyle) {
            this.isChartLoading = true;

            this.initQuery({
                source: "reviews",
                format: "snapshot",
                dimensionType: dimensionType,
                dimensionShowDeactivated: true,
                dimensionIncludeCustomQuestions: false,
                ignoreSafeguard: true,
                viewAs: this.viewAs,
                mode: "byParticipant",
            });

            if (this.reviewCycle.revieweeUser?._id) {
                this.addFilter("users", { _id: this.reviewCycle.revieweeUser._id }, "primary");
            }
            this.addFilter("reviewCycles", { _id: this.reviewCycle._id }, "primary");

            this.reportChartStyle = reportChartStyle;

            await this.$store.dispatch({
                type: "reviews/analytics/getReport",
                payload: { query: this.query },
            });

            this.prepareSnapshotChartSingle();

            this.graphSettings.series = ["Self", "Peers", "Direct R.", "Manager", "All"];

            this.isChartLoading = false;
        },
        initQuery(i) {
            this.query = {
                mode: i.mode || "default",
                viewAs: i.viewAs || "owner",
                format: i.format || "snapshot",
                export: i.export || false,
                source: i.source || "reviews",
                filters: {
                    primary: {
                        users: [],
                        managers: [],
                        localTeams: [],
                        perspectives: [],
                        skills: [],
                        categories: [],
                        reviewCycles: [],
                        periods: [],
                    },
                    secondary: {
                        users: [],
                        managers: [],
                        localTeams: [],
                        perspectives: [],
                        skills: [],
                        categories: [],
                        reviewCycles: [],
                        periods: [],
                    },
                },
                enableSecondaryFilters: false,
                groupBy: i.groupBy || "localTeam",
                dimensionType: i.dimensionType || "category",
                dimensionShowDeactivated:
                    typeof i.dimensionShowDeactivated !== "undefined"
                        ? i.dimensionShowDeactivated
                        : false,
                dimensionIncludeCustomQuestions:
                    typeof i.dimensionIncludeCustomQuestions !== "undefined"
                        ? i.dimensionIncludeCustomQuestions
                        : false,
                scatter: {
                    x: {},
                    y: {},
                },
                ignoreSafeguard:
                    typeof i.ignoreSafeguard !== "undefined" ? i.ignoreSafeguard : false,
                allowFallbackToFeedback:
                    typeof i.allowFallbackToFeedback !== "undefined"
                        ? i.allowFallbackToFeedback
                        : false,
            };
        },
        addFilter(type, value, level) {
            if (
                type !== "periods" &&
                !this.query.filters[level][type].some(function(f) {
                    return f?._id === value?._id;
                })
            ) {
                this.query.filters[level][type].push(value);
            } else if (type === "periods") {
                this.query.filters[level].periods = [{ start: value.start, end: value.end }];
            }
        },

        prepareSnapshotChartSingle() {
            const scaleType = this.report.settings?.scale?.type;

            this.graphSettings.datasetOverride = [
                {
                    hidden: false,
                },
                {
                    hidden: false,
                },
                {
                    hidden: this.query.source === "reviews" ? false : true,
                    fill: false,
                },
                {
                    hidden: this.query.source === "reviews" ? false : true,
                },
                {
                    hidden: true,
                    fill: false,
                },
            ];

            this.graphSettings.options = {
                layout: {
                    padding: {
                        left: 20,
                        right: 20,
                        top: 20,
                        bottom: 20,
                    },
                },
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        boxWidth: 15,
                        padding: 20,
                    },
                },
                scale: {
                    pointLabels: {
                        callback: function(pointLabel) {
                            if (pointLabel.length > 25) return pointLabel.substring(0, 24) + "...";
                            else return pointLabel;
                        },
                    },
                    ticks: {
                        display: scaleType !== "100" ? true : false,
                        min: 0,
                        max: scaleType ? parseInt(scaleType) : 5,
                        beginAtZero: true,
                        stepSize: scaleType !== "100" ? 1 : 100,
                    },
                },
                tooltips: {
                    enabled: true,
                    mode: "label",
                    callbacks: {
                        title: function(tooltipItems, data) {
                            var idx = tooltipItems[0].index;
                            return data.labels[idx];
                        },
                    },
                },
            };

            // fix scale of bar chart

            this.graphSettings.options.scales = {
                xAxes: [
                    {
                        display: false,
                        ticks: {
                            display: true,
                            suggestedMax: scaleType ? scaleType : 5,
                            beginAtZero: true,
                        },
                    },
                ],
            };

            // remove numbers for continuous scale

            if (scaleType === "100") {
                this.graphSettings.options.tooltips.callbacks.label = function(tooltipItems, data) {
                    return data.datasets[tooltipItems.datasetIndex].label;
                };
            }
        },
        generatePNG() {
            const canvas = this.$refs[`chart-${this.reportChartStyle}`]?.$refs?.canvas;
            if (!canvas) {
                return;
            }

            const image = canvas
                .toDataURL("image/png", 1.0)
                .replace("image/png", "image/octet-stream");

            const link = document.createElement("a");
            link.download = "AssessmentOverviewExport.png";
            link.href = image;
            link.click();
        },
    },
};
</script>
